// The Dr. Martens AI Lab mock pack — the demo's scripted question and its
// full typed-block response (block kinds → pages/Lab/blocks/index.js). Same
// authoring law as mock/lab/starbucks.js: readout first and VERDICT ONLY,
// CMO cultural-capital vocabulary (never engine internals), NAMED moves,
// digit-free modelView, provenance observed / projected / measured. Pure
// data, no imports (scripts/dump-lab-fixture.js evaluates the file).
//
// THE FIRST Dr. Martens PACK (2026-11-02, branch dr-marteens), built by
// two parallel sessions from two plans and merged into this one pack the
// same day: docs/plans/dr-martens-rebellion-lab/PLAN.md (the user: "generate
// new lab for dr marteens on topic: How can Dr. Martens make rebellion
// relevant again?", the question verbatim) and
// docs/plans/dr-martens-communities-lab/PLAN.md (the user: "i want you to
// generate new lab for dr marteens on topic: Which communities should Dr.
// Martens belong to next?"). The server side was already done — on the
// PROD database `brands.dr-martens` is enabled with an auth code — and
// contexts/SessionContext refuses a coded brand with no mock/lab pack, so
// registering this pack in mock/lab/index.js (with its briefing twin in
// mock/briefing/dr-martens.js) IS the login enable step; nothing to flip in
// any DB. TWO entries, both on the existing `community` starter type (the
// think script in mock/lab/stages.js already generic, untouched), item type
// `community`: FIRST `rebellion-relevance` (the first chip, the Weekly card
// and the briefing's ACT card — user call 2026-11-02, rebellion leads),
// SECOND `communities-next` (the second chip, the Weekly's archive, the
// briefing's KNOW / NOTE cards). A THIRD entry joined the same afternoon,
// `next-hotspot-store` on the existing `retail` type (the NEXT STORE
// paragraph below): the third chip, the Weekly's archive and one briefing
// ALERT card. The answers read the same PROD record
// through different lane regexes (rebellion: heritage bands 4 plays / +1;
// communities: heritage bands 7 / +0.8), so a lane's count differs between
// them; each entry's numbers are its own plan's. The persona is a fictional
// Alex — never a real executive of the house.
//
// REBELLION question (2026-11-02). Basis: the PROD database (user call:
// "use prod database if needed, there is no marteens data on dev" — the dev
// row is enabled=false with zero items), read 2026-11-02 by the plan
// (docs/plans/dr-martens-rebellion-lab/prod-queries.sql, output
// prod-reads-2026-11-02.txt and db-basis-2026-11-02.txt beside it) and
// RE-READ at build the same afternoon against PROD (the user allowed prod
// reads): every query returned the same rows, the served run unchanged.
// Serving
// rule per (brand, as_of): the completed GLOBAL run with the latest
// executed_at; mocked and deprecated items excluded; a pulse with actuality
// 0 and net valence 0 is "not read"; assessments (brand codes, community,
// styling, art direction) excluded from every lane and read on their own.
// SERVED RUN as_of 2026-08-24 (executed 2026-10-05, the backfill): Dr.
// Martens CIQ 65.39, raw 65.48, capital K 57.22, #12 of 19 in fashion
// (Nike 85.94 · adidas 85.32 · LV 81.55 · Dior 78.70 · Chanel 73.14 · Prada
// 70.48 · Uniqlo 70.22 · Lululemon 69.94 · Gucci 69.01 · Hermès 67.88 ·
// Saint Laurent 66.15 · Dr. Martens 65.39 · Valentino 64.74 · Bottega 64.65
// · Armani 64.29 · Jacquemus 63.65 · UGG 61.73 · Gap 54.56 · Zara 52.81);
// series 51.93 (26 Jan) → 55.23 (4 May) → 57.23 (29 Jun) → 62.18 (13 Jul)
// → 65.39, the step is July (raw 57.00 → 65.48 in one window).
// THE RECORD (98 items, 14 Jan → 24 Aug), by type (plays · read · avg nv ·
// avg base): collab 22 · 13 · +17 · 37.8; content 18 · 10 · +24 · 30.5;
// archive reissue 13 · 11 · +23 · 29.3; event 12 · 6 · +20 · 28.1; merch 9
// · 8 · +26 · 24.2; capsule 6 · 4 · +20 · 25.1; experience 6 · 5 · +30 ·
// 27.4. Served item-type scores: collab 95.7, content 93.2, archive 69.1,
// event 46.2, capsule 43.3, merch 41.5, EXPERIENCE 21.0 (the lowest).
// STRATEGY RECORD (plays · fit · read · nv): identity signal 46 · 0.48 · 31
// · +26; aesthetic innovation 40 · 0.41 · 23 · +27; opacity 4 · 0.40 · 3 ·
// +37; scarcity 4 · 0.50 · 3 · +16; fandom 3 · 0.30 · 2 · 0; average +22.0
// on the read plays (the quadrant: x = plays as a share of identity's 46,
// y = 50 + 2 × (nv − 22), identity clamped to 97).
// WHERE YOUR RECORD SCORES YOU (the cohorts block after the trend chart,
// 2026-11-02): six of the served type scores above, rounded (collab 96,
// content 93, brand codes 74, community 68, event 46, experience 21), the
// drivers from the by-type reads and the assessment text below. A MATRIX
// stood there until the same day — the three community reads × six traits,
// every cell 0 or 100 and every row identical — replaced on the user's
// call ("this chart looks off and doesn't provide valuable info"); the
// per-question grades that would make it a real heat grid live in each
// assessment's `attributes.rubric` on PROD, unread by either plan.
// THE COMMUNITY ASSESSMENTS: 26 Jan 66.6 ("an incredibly
// powerful, self-sustaining global community rooted in decades of music and
// subcultural history … lacks formal owned community infrastructure",
// "relies almost entirely on rented social platforms and has no active
// brand-operated forums, Discord servers, or tiered loyalty programs",
// strongest "universal cultural shorthand across diverse subcultures",
// fandom "styling, customization, and deep debates over manufacturing
// heritage"); 4 May 65.0 ("organic fandom thrives on rented platforms and
// secondary markets, driven by shared rituals like the boot breaking-in
// process", weakest owned spaces); 10 Aug 68.3 ("thrives on rented
// platforms like Reddit and TikTok", weakest owned infrastructure again).
// Brand codes 70 → 71 → 74, weakest "verbal and sonic codes" every time
// ("lacks a dedicated sonic identity").
// THE REBELLION LANES since 1 Jan (a regex over title + summary, the plan's
// prod-queries.sql; DM plays · read · nv · best | board plays · brands ·
// typical (median base) · ceiling (p75) · received · board nv): heritage
// bands 4 · 3 · +1 · 33 | 12 · 4 · 37.6 · 40.6 · 87 · +45; underground
// designers 13 · 9 · +18 · 73 | 20 · 6 · 38.1 · 43.0 · 73 · +33; scene
// nights 8 · 4 · +40 · 53 | 68 · 16 · 29.9 · 36.5 · 73 · +30; young makers
// 3 · 1 · +47 · 47 | 28 · 11 · 32.2 · 37.1 · 80 · +37; pride and identity
// 2 · 2 · +24 · 47 | 3 · 2 · 23.0 · 37.2 · 93 · +42; pop licences 4 · 2 ·
// +27 · 53 | 12 · 5 · 34.5 · 36.7 · 80 · +27; causes and protest 0 (the
// one regex hit is the Pride 1460's donation line, not a cause play) | 7 ·
// 2 · 30.7 · 33.2 · 67 · +47. Rings (the field's highest base per lane,
// other brands): adidas "Original Forever" 53.2; Rick Owens × adidas
// ClimaCool SS27 tracksuits 56.7; adidas Home of Soccer PinkPantheress
// concert 44.0 (Gap's custom Met Gala look, 62.4, is a regex false hit and
// was skipped); Nike HBCU Swingman Classic 48.4; Gucci at the 2026 Met Gala
// 55.1; adidas × Brain Dead × Disney 42.0; LV × UNICEF Silver Lockit 37.6.
// DR. MARTENS PLAYS (base · best · nv per window): Metallica collection
// 33.9 · 33 · −7, −7, 0, +27; Metallica campaign 39.2 · 33 · 0, 0, 0; The
// Specials in Camden 31.7 · not read; Nine Inch Nails 40.4 · 0; Rick Owens
// FW26 44.4 · 27 · +27, −14; Rick Owens Megalace 40.4 · 73 · +60, +73, 0
// (the best read on the record); Futura 38.3 · 0; Supreme Postal 41.1 · 53
// · +53, +33, +6, 0, 0; Supreme 4-hole 42.9 · 40; MM6 Margiela 41.4 · 0, 0;
// Supreme snakeskin 34.4 · 33; A-COLD-WALL* 25.0, fragment ×2 33.9 / 34.4,
// Wasted Youth 39.9 not read; Rick Owens June 46.9 (the highest grade) · 0,
// 0; Wacko Maria 31.3 · 40; the City Daze canal party 22.5 / 26.2 (two
// items) · 53; Barry Keoghan at the Vanity Fair party 36.4 · 0; Journeys
// "Life on Loud" 24.7 · 53; Central Saint Martins alliance 26.3 · 47; the
// LGBTQIA+ artists' collection 37.2 · 47; the Pride 1460 23.0 · 27 · 0;
// National Gallery 35.4 · 0; BT21 38.9 · 53; Brewer Street concept store
// 39.3 · 40 (the one owned room). Board per lane: heritage bands adidas 9 ·
// 8 · +45; designers adidas 10 · 6 · +39, Nike 4 · +29, Prada 3 · +42;
// scene nights adidas 22 · 14 · +32, UGG 8 · +28, Nike 7 · +49, Valentino 3
// · +67; young makers adidas 5 · +30, Chanel 5 · +45, Uniqlo 5 · +18, Hermès
// 2 · +57; pride Lululemon 2 · +20, Gucci 1 · +87; causes Uniqlo 6 · +46, LV
// 1 · +53.
//
// OBSERVED (public, verified 2026-11-02; full sheets beside the plan):
// Dr. Martens FY26 results RNS, 19 May 2026 — revenue £764.9m (−2.9%),
// boots −8% and 52% of revenue (from 57%), shoes +19%, Brewer Street ASP
// "over 15% higher than other London stores", "In FY27, we will lean in
// with increased investment in the brand"; the 5 Jun 2025 strategy update
// transcript (the CEO's "rebellious self-expression … too narrow … alienated
// others" — background only since 2026-11-02, user call "dont mention chief
// executive": no copy in the pack or its briefing names the CEO); "With Bouncing Soles" (launch date UNRESOLVED —
// the record holds it on 27 Jan 2026, press on 24 Sep 2026 — copy says
// "this year"); ReWair resale, 30 Dec 2025 (43% of US resale customers new
// to the brand); a broker downgrade on 2 Nov 2026 on subdued search
// (header only). Piper Sandler 26th Teen Survey, published 15 Oct 2026 (n =
// 8,934, fielded Aug – Sep 2026: Dr. Martens outside the top ten favourite
// shoes, Birkenstock 5%, UGG 4%, the list closing at 1%). Harvard Youth
// Poll Fall 2026, 22 Oct 2026 (68% of 18–29s call corporate power a
// serious threat). Morning Consult Gen Z brand trust 2026 (94% of 3,200+
// brands trusted less by Gen Z than by all adults). Dazed Studio
// "Parafaith", 8 Jul 2026 (2,000+ Gen Z and Gen Alpha: 1% celebrities, 25%
// friends, 71% human-made culture matters more). Turnstile's free benefit
// show at the Washington Monument, 24 Oct 2026 (~60,000 by the organisers,
// >$240,000 raised — copy says "over two hundred thousand dollars" until a
// primary confirms more). Portland hardcore, 28 Jul 2026 (70% of the crowd
// 21 or under, promoters' estimate). Outbreak Festival photo story, 28 Aug
// 2026 (the black platform boot, no brand named). hashtagradar TikTok
// counters, read 2026-11-02 (#goth 3.6M, #punk 1.8M, #drmartens 72.5K,
// cumulative). Rivals: Nike Q1 FY27, 1 Oct 2026 (Converse $263M, −28%,
// every territory); Converse's new CEO and "a sport company" reset, 7 May
// 2026; VF Q2 FY27, 28 Oct 2026 (Vans $547.6M, −10%); Vans "Off The Wall",
// 25 Mar 2026 (SZA, Hayley Williams, Travis Barker, Turnstile's Franz
// Lyons; "misfits and malcontents"); Warped Tour 2026, five stops; Diesel ×
// Tinder Pride 2026 ($200,000 to Outright International); Glenn Martens'
// Diesel exit, 18 Sep 2026. Converse, Vans and Diesel have no vocab slug:
// their matrix rows are OBSERVED, shown as measured (user call 2026-11-02),
// never `similar` tiles.
// GOOGLE TRENDS (ours, docs/plans/dr-martens-rebellion-lab/
// trends-2026-11-02.json): one comparative SerpApi call, worldwide,
// 2024-01-01 → 2026-11-01, "Dr Martens, Birkenstock, Converse, Vans",
// monthly means, Vans Aug 2024 = 100; the partial Dec 2023 bucket dropped.
// First-12 → last-12 means: Dr Martens 14.8 → 13.1, Birkenstock 45.6 → 55.3
// (+21%), Converse 63.9 → 55.1 (−14%), Vans 86.0 → 85.2. A first call with
// Diesel was REJECTED — "Diesel" reads as the fuel and flattens the chart.
// CONSIDERED AND DROPPED (stale or unsourced): Piper Sandler 2024's
// Dr. Martens #5 among non-binary teens (2024); Pinterest Predicts 2026
// "Vamp Romantic" (data window Sep 2024 – Aug 2025); a Gen Z brand radar
// (agency social listening, 2025); YouGov's "stand for something" (window
// to Nov 2025); UK late-night venues −26.4% (aggregator only); any positive
// 2025–26 executive quote on rebellion (none exists); a 2025–26 "Dr.
// Martens Presents" live series (none). PROJECTED: the prices — +1.0 / +0.8
// / +0.6 = +2.4, 65.39 → ~67.8, past Saint Laurent's 66.15 and level with
// Hermès's 67.88; the cohorts are an author's read of the dated facts
// above. The H1 FY27 interims land late November 2026: re-read the boots
// tile when they do.

//
// COMMUNITIES question (2026-11-02). Basis: the plan's 2026-11-02 PROD read
// (the skill script with the community regex, plus the queries in
// docs/plans/dr-martens-communities-lab/prod-queries.sql, after the user
// allowed prod reads); the build session's same-day re-query was blocked by
// the classifier ("Production Reads"), so every measured number below is
// that morning read. Serving rule per (brand, as_of): the completed GLOBAL
// run with the latest executed_at; mocked and deprecated items excluded; a
// pulse with actuality 0 and net valence 0 is "not read"; assessments
// (brand codes, community, styling, art direction) excluded from every lane
// count and read on their own. SERVED RUN as_of 2026-08-24 (executed
// 2026-10-05, the backfill that brought the brand on): Dr. Martens CIQ
// 65.39, raw 65.48, capital K 57.22, rank 12 of 19 in fashion (Saint
// Laurent 66.15 the next rung, Hermès 67.88, Gucci 69.01); series 51.93
// (26 Jan) → mid-fifties all spring → 57.23 (29 Jun) → 62.18 (13 Jul) →
// 65.39, a step in July and flat since. Item types: collab 95.7 (22),
// content 93.2 (18), archive reissue 69.1 (13), event 46.2 (12), capsule
// 43.3 (6), merch 41.5 (9), experience 21.0 (6). THE COMMUNITY ASSESSMENTS
// (query 5): 26 Jan 66.6 (music and subcultural history, a lifelong
// collector base, no owned infrastructure), 4 May 65.4 (rented platforms,
// secondary markets, the break-in ritual), 10 Aug 68.3 (a shared
// alternative identity, Reddit and TikTok, break-in rituals, the debate
// over manufacturing) — every one marks the missing owned home; the board's
// August community reads put Docs 8th of 19, under its own brand codes
// (74.0). HOW THE RECORD RATES YOUR COMMUNITY (the cohorts block
// after the trend chart, 2026-11-02): the board's August community reads,
// the top nine of 19 rounded (Hermès 89.3 · Nike 89.0 · Chanel 79.7 · adidas
// 78.2 · Prada 74.9 · Lululemon 73.0 · LV 71.6 · Dr. Martens 68.3 · Dior
// 67.4), each other brand's drivers from query 3 (board per lane) and query
// 7 (best-read plays), Docs's from the three assessments. A binary MATRIX
// stood there until the same day (the three reads × seven traits, every cell
// 0 or 100), replaced on the user's call — the rebellion entry's twin fix. COMMUNITY LANES since 1 Jan (query 1; n / avg base / avg net
// valence / best presence / read): art & art school 17 / 31.6 / +10.8 / 47
// / 9; Japan & street insiders 15 / 35.6 / +12.2 / 67 / 9; Made in England
// craft 14 / 33.8 / +29.1 / 73 / 9; designer runway 11 / 38.1 / +19.5 / 73
// / 5; local nights & hangouts 9 / 27.4 / +36.4 / 80 / 7; women & girls 8 /
// 32.3 / +21.8 / 73 / 5; anime, k-pop & characters 7 / 33.9 / +34.6 / 53 /
// 5; heritage bands 7 / 34.8 / +0.8 / 33 / 4; queer & pride 2 / 30.1 /
// +23.5 / 47 / 2; western 1 / 27.3 / +33.5 / 47 / 1. LANE BANDS (query 4,
// board median / p75 of base, max presence): rooms 29.0 / 37.4 / 73 (the
// arena's `received` is 80 — the beacon store sits in Docs's lane regex,
// not the board's, so the band's max is lifted to it); anime 35.9 / 41.0 /
// 93; makers & repair 34.2 / 39.4 / 93; heritage bands 35.2 / 37.9 / 80; art
// school 28.0 / 33.8 / 80; Japan street 38.1 / 39.7 / 67; queer 22.3 / 26.5
// / 67; western 33.5 / 37.1 / 53. The arena's dots are each play's GRADE
// (base), the band's own scale — the plan listed best presence, which reads
// in the notes and the pairs instead. STRATEGY RECORD ON COMMUNITY PLAYS
// (query 8, plays / read / reception / valence): Docs aesthetic 24 / 14 /
// 27.5 / +26.8, identity 24 / 15 / 24.0 / +20.9, fandom 2 / 2 / 0 / 0,
// opacity 2 / 1 / 53.0 / +53, scarcity 2 / 2 / 0 / 0; the rest of fashion
// aesthetic 316 / 41.3, identity 288 / 39.6, scarcity 92 / 41.9, fandom 85 /
// 40.2, opacity 52 / 35.4. THE BOARD PER LANE (query 3, n / avg valence):
// heritage bands Docs 7 / +0.8, adidas 5 / +32.8, Hermès 4 / +45.2, Nike 4
// / +33.5; rooms adidas 22 / +32.9, Dior 17, LV 13, Nike 10, Docs 6 /
// +35.8, UGG 6 / +30; anime Uniqlo 10 / +28.5, Nike 8, adidas 7 / +55.6,
// Gucci 5 / +63.3, Docs 3 / +50; makers & repair adidas 32, Hermès 23,
// Bottega 19, Nike 17, Docs 15 / +32.8. PRECEDENTS for `similar` (query 7
// and the k-pop read, vocab slugs, base): Hermès "Disque Jockey Club" 38.1
// (73); Valentino Beauty House Party 35.8 (67); Uniqlo UT × ZO&FRIENDS 33.3
// (67); Chanel × Karina 26.0 (67); Dior × Jimin ARIRANG 34.2 (53); Dior
// SCAD FASH exhibition 29.5 (80); Valentino Rockstud reworked 36.8 (67).
// Birkenstock, Timberland and Converse are rows in the "who holds" matrix by
// user call (2026-11-02), authored from the public facts below; none has a
// vocab slug, so none sits in `similar`.
//
// PUBLIC FACTS (verified 2026-11-02; tiers and URLs in the plan). Dr.
// Martens plc FY26 (19 May 2026): revenue £764.9m −2.9%; shoes +19% to 31%
// of revenue, boots −8% to 52%; full-price DTC US +14%, APAC +15%, EMEA
// −13%; the craft-curator share a record; the call: the beacon store's weekly
// events, selling price ~15% above other London stores, US resale +73%.
// Strategy Update (5 Jun 2025): "rebellious self-expression" called too
// narrow, three buyer segments (style seekers, craft curators, alternative
// individuals). AGM statement (15 Jul 2026): Japan and Korea performing
// well. Crowds: Eventbrite "Reset to Real" (n=4,051 US + UK 18–35, published
// Jan 2026) 89% want events that connect them to their community — the
// borderline row, replace with a 2026 edition; Music Venue Trust 2025
// report (Jan 2026) UK grassroots audiences +13% to ~21m, 53% of venues no
// profit; Live Nation Australia Gen Z study (Apr 2026, n=1,411) 86% say
// dressing like the artist is central; Netflix H2 2025 engagement, KPop
// Demon Hunters 481.6m views; Converse's k-pop ad pulled within two weeks
// (Sep 2026); hashtagradar TikTok counters read 2026-11-02 (#goth 3.6M
// posts against #drmartens 72.5K, the cache undated, relative scale only).
// Rivals: adidas × SATISFY "Circle Pit" run and the Ozzy "Birmingham" pair;
// Vans brought back Warped Tour; UGG × Willy Chavarria; Birkenstock ×
// sacai, closed-toe a growing share; Timberland × Jacquemus, × Louis
// Vuitton, PRO × NASCAR, in the fall 2026 teen top ten for the first time;
// Converse Q1 FY27 −28%. The teen survey (fall 2026, n≈9,000 US teens):
// Dr. Martens in no top ten. REJECTED, never in copy: "Docs" as a rebrand;
// "Dr. Martens Presents" as a current series, any venue partnership or
// 2025–26 festival presence (Back Room Sessions is NEW, never "returning");
// a 2025 or 2026 Pride collection or donation; a k-pop ambassador or the
// Musinsa partnership; any band collab after Metallica / Nine Inch Nails;
// "subcultures" as a CEO quote; "Tough As You" as current positioning;
// women's / Gen Z share, NPS, craft-curator percentage, marketing budget
// (none published); the Piper Sandler rank (stale 2020); Depop +41%
// (stale); Confidant/Vytal 45% (stale); Eventbrite anime raves +82%
// (stale); unverifiable metal revenue figures; rival estimates; any named
// executive in UI copy.
// GOOGLE TRENDS: one comparative worldwide SerpApi call 2026-11-02, "punk
// rock, emo night, anime convention, shoe repair", monthly means Jan 2024 →
// Oct 2026 (the point the script labels Dec 2023 dropped), busiest month of
// any term = 100 — the raw fetch is docs/plans/dr-martens-communities-lab/
// trends-2026-11-02.json. First- vs last-twelve-month means: punk rock 41.7
// → 57.2 (×1.37, peak Feb 2026 = 80), shoe repair 50.9 → 69.4 (×1.36, peak
// Apr 2026 = 100), anime convention 9.8 → 14.9 (×1.52, peak May–Jul 2026 =
// 20), emo night 8.6 → 8.4 (flat, the ghost). PROJECTED: the prices — +1.0
// / +0.9 / +0.7 = +2.6, 65.39 → ~68.0, past Saint Laurent and Hermès; the
// cohorts and the "who holds" matrix are an author's read of the dated
// facts above. RE-CHECK before shipping: H1 FY27 results (12 Nov 2026) for
// fresher region / resale figures in the stats tiles.
//
// NEXT STORE question (2026-11-02, docs/plans/dr-martens-next-store-lab/
// PLAN.md; the user: "new lab for dr marteens on topic: What's the next
// cultural hotspot where Dr. Martens should open a store?", the question
// worded "Which cultural hotspot gets our next store?" by user call, the
// topic's wording an alias). The plan was written as the FIRST pack; the
// rebellion and communities builds made the pack first, so this entry is
// APPENDED third on the existing `retail` type (Site scout, the Starbucks
// `next-store-usa` precedent; its think script in mock/lab/stages.js is
// generic, untouched), item type `experience`. Verdict (user checkpoint):
// Mexico City's Roma, opened as a BEACON (over São Paulo, Seoul, a US
// scene), São Paulo tested by a pop-up first. Basis: the plan's 2026-11-02
// PROD read (`db_basis.sh` with the store regex, plus the nine queries in
// prod-queries.sql beside the plan); the build session's same-day re-read
// was blocked by the classifier ("Production Reads"), so every measured
// number is that morning read. Serving rule and exclusions as above.
// SERVED RUN as_of 2026-08-24: 65.39, #12 of 19 (Saint Laurent 66.15,
// Hermès 67.88 the next rungs). Item types: EXPERIENCE 21.0 on 6 items,
// the lowest, yet its best-read type per play (6 plays · 5 read · avg best
// 44.0 · nv +29.7). THE EXPERIENCE SHELF (base · best per window): Doctor's
// Orders concept store 39.3 · 40; Brewer Street concept store 37.3 · 47, 0,
// 0; Rebels + Icons at MoPOP 23.3 · not read; the canal takeover 22.5 · 53;
// the beacon and brand centre formats 22.1 · 80, 0; the LiSA exhibition
// 19.9 · 0, 0. STORE OPENINGS on the board (Q2, plays · read · avg best ·
// max): Dr. Martens 3 · 3 · 55.7 · 80, third-best average (Chanel 62.3,
// Zara 60.0 on 3 reads, Hermès 52.5 on 14). THE MUSIC LANE (Q6): Dr.
// Martens 9 plays · 6 read · avg best 28.7 · max 53 against the rest of
// fashion 117 · 74 · 49.8 · 87; Metallica 33.9 · 33 (nv −7, −7, 0, +27),
// Nine Inch Nails 40.4 · 0, Rick Owens June 46.9 · 0, 0, LiSA 15 Years
// Journey 37.2 · 40. CITY LANES (Q1, fashion since 1 Jan, plays · brands ·
// read · avg best · Dr. Martens): New York 118 · 18 · 69 · 45.1 · 2; Paris
// 89 · 13 · 54 · 51.5 · 0; Los Angeles 83 · 17 · 58 · 47.0 · 2; London 72 ·
// 17 · 43 · 46.3 · 10; Milan 56 · 16 · 35 · 50.1 · 1; Tokyo 19 · 10 · 14 ·
// 35.2 · 3; Seoul 16 · 12 · 6 · 50.0 · 1; Bangkok 15 · 6 · 10 · 64.0 · 0;
// Lisbon 3 · 3 · 1 · 60.0; Mexico City 3 · 2 · 2 · 33.5 · 0 (Nike 2, Armani
// 1); São Paulo 0. The matrix (Q7) scales each city column to its busiest
// brand; the plan did not pull per-cell titles, so a cell names a play only
// where the plan's lists do, otherwise its count. ARENA lanes (Q8 / Q9,
// fashion experience plays since 1 Jan, median / p75 base, best, received):
// stores 23.4 / 31.5, Hermès Maison Bond Street 49.1; gigs 30.1 / 34.0,
// Jacquemus Beach Club Takeover 46.7; exhibitions 25.9 / 32.5, LV The Place
// Bangkok 53.3; pop-ups 24.7 / 30.2, LV Hotel London 49.2; received 80 on
// each. Own dots are GRADES, placed one lane each by hand. `similar` pts
// are BASE grades like the siblings' (Q3): Hermès 49.1, Dior Saint-Tropez
// 31.2, Saint Laurent Café 26.4, Zara × Bad Bunny 27.1, Nike NIGO 37.0,
// Jacquemus 46.7, LV Hotel London 49.2, Valentino Beauty House Party 35.8
// (the plan listed best reception; the sibling moves price strength).
// PUBLIC FACTS (verified 2026-11-02; tiers and URLs in the plan): Dr.
// Martens plc FY26 (19 May 2026): 240 own stores, 19 opened / 18 closed,
// the estate "broadly flat", a four-tier store model, ~30 stores to brand
// centres, "the beacons will be new locations", EMEA retail −8.3%, Korea
// +34.2%, Thailand 5 partner stores; the transcript: Brewer Street ASP
// "over 15% higher" than other London stores on "about 60% of the SKUs",
// Dosan Park +20%. Crosby (the Latin America distributor), 2 Sep 2026:
// drmartens.com.mx and a first store in colonia Roma before year end — a
// search on build day found no opening yet (copy says "this winter").
// Spotify, 24 Jul 2026: emo / pop-punk streams in Mexico ~2× from 2019 to
// 2025, monthly listeners +66% since 2022, 25–34 over half of streams,
// 18–24 a fifth. IFPI GMR 2026: Latin America +17.1%, Mexico #10 +13.3%.
// Vive Latino 2026: 160,000 over two days. Corona Capital 2025: over 40%
// travel in (never "236,000 attendees", those are day-entries). Time Out
// 2026: Jongno 3-ga #1 and Koenji #8 coolest neighbourhoods, nightlife
// Bangkok 1 / São Paulo 5, Gen Z Mexico City 8 → 17, best cities Lisbon
// 12 → 49. Euromonitor 2025: Bangkok the most-visited city. Cushman 2025:
// Oscar Freire rents +65%, the fastest riser. Nike's SoHo flagship closed
// 10 Jan 2026. OPENINGS rows (observed, off-board brands monogram-fall-back,
// never `similar`): Salomon Roma Norte (Mar 2026), adidas Originals
// Pinheiros (17 Nov 2025), Supreme Seongsu (12 Sep 2026), Dr. Martens Dosan
// Park (18 Mar 2026), Palace Zhangyuan (23 May 2026), Vans Brera (Jul
// 2026), Birkenstock Shinsaibashi (16 Apr 2026), Carhartt WIP Le Flon (4 Dec
// 2025). GOOGLE TRENDS (ours, trends-2026-11-02.json beside the plan): one
// comparative SerpApi call, geo MX, "dr martens, converse, vans", monthly
// means; the bucket labelled Dec 2023 is a part week and was DROPPED, and
// the rest RE-SCALED so the busiest remaining month (Converse, Jan 2024)
// reads 100 (raw 72). First- vs last-twelve-month means: Dr. Martens 8.3 →
// 7.8 (flat, Sep–Oct 2026 unmoved by the online launch), Converse 84.8 →
// 52.0, Vans 80.1 → 70.8. CONSIDERED AND DROPPED: every social counter
// (aggregator snapshots, stale or undated); "Brewer Street is the biggest
// UK store" (false); "60% fewer SKUs" (a misquote); a like-for-like figure
// (none published); "Dr. Martens Presents" as a current series (the move
// BRINGS IT BACK); "Tough As You" as the platform; the Piper Sandler rank
// (stale); the old Mexico City store listings (all Mexican stores closed
// Feb 2022). PROJECTED: the geoCompare's scene readiness and the quadrant
// (an author's composite; the quadrant's x stretches readiness so 70 sits
// on the middle line, its y is 5 + 0.8 × the room left, flipped from the
// plan's presence axis because the renderer tints the TOP-RIGHT as the
// recommendation), the cohorts, and the prices — +1.0 / +0.8 / +0.5 =
// +2.3, 65.39 → ~67.7, past Saint Laurent and a fifth of a point short of
// Hermès. The plan's `pts` on each move is NOT carried (a proposal's pts
// replaces its CIQ delta on screen). RE-CHECK before shipping: H1 FY27
// results (12 Nov 2026) for the store count and any Mexico or beacon news,
// whether the Roma store has OPENED (then the verdict reads "is open" and
// the beacon is an upgrade, not a launch), Corona Capital 20–22 Nov 2026.

export const DR_MARTENS_LAB = {
  brand: "dr-martens",
  name: "Dr. Martens",
  // the demo persona greeted on the Lab — this Alex is Dr. Martens' own
  person: "Alex",
  // THE WEEKLY PERSPECTIVE's one card (pages/Leaderboard/WeeklyOne): the
  // rebellion question under the entry's own words and type, measured on
  // this pack's own day (every pack's day differs — ugg 10-09, tiffany
  // 10-14, estee 10-16, starbucks 10-19, adidas 10-29). The preview is the
  // answer's own numbers: the trend is the brand's search line, every other
  // month from January 2025 to September 2026 (October 2024 → October 2026,
  // 20 → 14 = −30%); the ring the young adults wary of big companies; the
  // bars the crowd's average read of the made-with plays (the canal party,
  // Central Saint Martins, the artists' collection, Life on Loud), the
  // designer lane and the band lane.
  weekly: {
    sources: 1384216,
    cards: [
      {
        entry: "rebellion-relevance",
        measured: "2026-10-30",
        preview: {
          trend: {
            value: "−30%",
            label: "October search",
            series: [16, 12, 9, 11, 16, 23, 15, 11, 10, 9, 13],
          },
          ring: { value: 68, label: "Young adults wary of big companies" },
          bars: {
            title: "What the crowd reads",
            rows: [
              { label: "Made with a scene", value: 50 },
              { label: "Designer collabs", value: 18 },
              { label: "Band licences", value: 1 },
            ],
          },
        },
      },
    ],
  },
  entries: [
    {
      id: "rebellion-relevance",
      // the rebel slogan is spent, the rebels are not. A room the scene
      // books itself, a boot it makes, a pair it keeps
      itemType: "community",
      type: "community",
      question: "How can Dr. Martens make rebellion relevant again?",
      aliases: [
        "how can doc martens make rebellion relevant again",
        "how can docs make rebellion relevant again",
        "who is rebelling now and are they wearing docs",
        "which subcultures could make dr martens rebel again",
        "is dr martens still rebellious",
        "is rebellion still relevant for dr martens",
        "where does rebellion live now",
        "how do we make rebellion relevant again",
        "how do we win back the rebels",
        "how can dr martens be rebellious again",
        "how do we make our brand rebellious again",
      ],
      askedOn: "2026-11-02",
      blocks: [
        {
          kind: "readout",
          provenance: "measured",
          verdict:
            "Rebellion still lives in your boot, but not in your messages. Today's rebels distrust brands and fill hardcore shows in black boots with no name on them. Your record reads you warmest when you make something with a scene, and coldest when you borrow a band's or a designer's name.",
        },
        {
          kind: "stats",
          provenance: "observed",
          insight:
            "The boot that dressed every scene is the part of the house that stopped, and the young no longer name it. The rebellion did not leave. It turned against brands and stopped listening to famous faces, so the way back is a room the scene trusts, not a louder message.",
          items: [
            {
              label: "Teens' favourite shoes",
              value: "Not top 10",
              hint: "this autumn's survey of nearly nine thousand American teens, where Birkenstock and UGG made the top five and the list closes at one percent. The young no longer pick the rebel's boot by name",
            },
            {
              label: "Your boots, last year",
              value: "−8%",
              hint: "your boot revenue in the year to March, now about half your sales from fifty-seven percent, while your shoes grew nineteen. The icon of every scene you dressed is the part that stopped",
            },
            {
              label: "Wary of big companies",
              value: "68%",
              hint: "of Americans aged eighteen to twenty-nine this autumn who call the power of large corporations a serious threat. Rebellion now points at brands, so a brand cannot announce it",
            },
            {
              label: "Moved by a famous face",
              value: "1%",
              hint: "of young people in a global youth culture study this summer who say celebrities shape what they buy, against twenty-five percent for friends. The rebel follows a friend into a room",
            },
          ],
        },
        {
          kind: "shift",
          insight:
            "The rebels are back in the room and the room has no brand in it. The pit is young, the shows are free, and the uniform is a black boot nobody names. The last row is the lesson. The sneakers that sold rebellion as a message are the ones shrinking.",
          title: "Where rebellion lives now",
          provenance: "observed",
          note: "Six public numbers from the past year. Each line says what the figure counts and why it is here. The last one is the risk, not a signal.",
          rows: [
            {
              label: "A free hardcore show",
              context:
                "The crowd a hardcore band drew to a free benefit show in Washington in late October, by the organisers' count, raising over two hundred thousand dollars from its fans. Rebellion this year is a free room with a cause the crowd chose itself.",
              value: "60,000",
            },
            {
              label: "Under twenty-one in the pit",
              context:
                "Promoters' estimate of the share of their hardcore crowd aged twenty-one or under, in one American city's new scene this summer. The pit is young again, and it is the crowd your boot was made for.",
              value: "70%",
            },
            {
              label: "#goth against #drmartens",
              context:
                "TikTok posts on the goth tag against your own, about three and a half million to seventy thousand, as read this week. The look travels without your name on it.",
              value: "50 to 1",
            },
            {
              label: "Human-made matters more",
              context:
                "Share of young people in a global youth culture study this summer who say human-made culture matters more as AI spreads. The made-with is the rebel's proof.",
              value: "71%",
            },
            {
              label: "Brands the young trust less",
              context:
                "Share of more than three thousand tracked brands that young Americans trust less than all adults do, read this year. A brand that tells the young it is rebellious starts behind.",
              value: "94%",
            },
            {
              label: "The punk's sneaker, last quarter",
              context:
                "Revenue of the canvas-sneaker brand the punks wore, in the quarter to August, down in every territory while its owner turns it toward sport. Heritage rebellion sold as a message is the lane that is shrinking.",
              value: "−28%",
            },
          ],
        },
        {
          kind: "trendCompare",
          insight:
            "Your search runs on the boot season, and the season is shrinking. This October searched at fourteen on the chart against twenty two years ago, while Birkenstock searched a fifth more over the last year. The rebel sneakers sit beside you. Converse fell by a seventh and Vans held flat on its misfits campaign. Saying rebellion louder has not moved search for anyone.",
          title: "Where the search went",
          provenance: "observed",
          note: "Worldwide Google search interest for four shoe brands, monthly means from January 2024 to October 2026 on one scale. The busiest month of any of them reads 100.",
          highlight: {
            from: "2026-08-01",
            to: "2026-10-31",
            label: "Boot season, this year",
          },
          series: [
            {
              key: "dr-martens",
              label: "Dr. Martens",
              color: "#a8475a",
              points: [
                { d: "2024-01-01", v: 16 },
                { d: "2024-02-01", v: 13 },
                { d: "2024-03-01", v: 12 },
                { d: "2024-04-01", v: 11 },
                { d: "2024-05-01", v: 10 },
                { d: "2024-06-01", v: 10 },
                { d: "2024-07-01", v: 11 },
                { d: "2024-08-01", v: 13 },
                { d: "2024-09-01", v: 17 },
                { d: "2024-10-01", v: 20 },
                { d: "2024-11-01", v: 24 },
                { d: "2024-12-01", v: 22 },
                { d: "2025-01-01", v: 16 },
                { d: "2025-02-01", v: 13 },
                { d: "2025-03-01", v: 12 },
                { d: "2025-04-01", v: 10 },
                { d: "2025-05-01", v: 9 },
                { d: "2025-06-01", v: 10 },
                { d: "2025-07-01", v: 11 },
                { d: "2025-08-01", v: 14 },
                { d: "2025-09-01", v: 16 },
                { d: "2025-10-01", v: 18 },
                { d: "2025-11-01", v: 23 },
                { d: "2025-12-01", v: 18 },
                { d: "2026-01-01", v: 15 },
                { d: "2026-02-01", v: 12 },
                { d: "2026-03-01", v: 11 },
                { d: "2026-04-01", v: 10 },
                { d: "2026-05-01", v: 10 },
                { d: "2026-06-01", v: 9 },
                { d: "2026-07-01", v: 9 },
                { d: "2026-08-01", v: 13 },
                { d: "2026-09-01", v: 13 },
                { d: "2026-10-01", v: 14 },
              ],
            },
            {
              key: "birkenstock",
              label: "Birkenstock",
              color: "#FDE047",
              points: [
                { d: "2024-01-01", v: 26 },
                { d: "2024-02-01", v: 27 },
                { d: "2024-03-01", v: 35 },
                { d: "2024-04-01", v: 46 },
                { d: "2024-05-01", v: 61 },
                { d: "2024-06-01", v: 71 },
                { d: "2024-07-01", v: 72 },
                { d: "2024-08-01", v: 62 },
                { d: "2024-09-01", v: 40 },
                { d: "2024-10-01", v: 33 },
                { d: "2024-11-01", v: 44 },
                { d: "2024-12-01", v: 45 },
                { d: "2025-01-01", v: 30 },
                { d: "2025-02-01", v: 30 },
                { d: "2025-03-01", v: 41 },
                { d: "2025-04-01", v: 54 },
                { d: "2025-05-01", v: 61 },
                { d: "2025-06-01", v: 84 },
                { d: "2025-07-01", v: 78 },
                { d: "2025-08-01", v: 66 },
                { d: "2025-09-01", v: 42 },
                { d: "2025-10-01", v: 36 },
                { d: "2025-11-01", v: 46 },
                { d: "2025-12-01", v: 45 },
                { d: "2026-01-01", v: 31 },
                { d: "2026-02-01", v: 33 },
                { d: "2026-03-01", v: 48 },
                { d: "2026-04-01", v: 68 },
                { d: "2026-05-01", v: 79 },
                { d: "2026-06-01", v: 82 },
                { d: "2026-07-01", v: 80 },
                { d: "2026-08-01", v: 71 },
                { d: "2026-09-01", v: 46 },
                { d: "2026-10-01", v: 35 },
              ],
            },
            {
              key: "converse",
              label: "Converse",
              color: "#60A5FA",
              points: [
                { d: "2024-01-01", v: 62 },
                { d: "2024-02-01", v: 65 },
                { d: "2024-03-01", v: 69 },
                { d: "2024-04-01", v: 67 },
                { d: "2024-05-01", v: 67 },
                { d: "2024-06-01", v: 61 },
                { d: "2024-07-01", v: 64 },
                { d: "2024-08-01", v: 66 },
                { d: "2024-09-01", v: 59 },
                { d: "2024-10-01", v: 56 },
                { d: "2024-11-01", v: 63 },
                { d: "2024-12-01", v: 57 },
                { d: "2025-01-01", v: 47 },
                { d: "2025-02-01", v: 47 },
                { d: "2025-03-01", v: 53 },
                { d: "2025-04-01", v: 54 },
                { d: "2025-05-01", v: 53 },
                { d: "2025-06-01", v: 50 },
                { d: "2025-07-01", v: 56 },
                { d: "2025-08-01", v: 61 },
                { d: "2025-09-01", v: 49 },
                { d: "2025-10-01", v: 45 },
                { d: "2025-11-01", v: 53 },
                { d: "2025-12-01", v: 49 },
                { d: "2026-01-01", v: 42 },
                { d: "2026-02-01", v: 45 },
                { d: "2026-03-01", v: 62 },
                { d: "2026-04-01", v: 81 },
                { d: "2026-05-01", v: 74 },
                { d: "2026-06-01", v: 50 },
                { d: "2026-07-01", v: 51 },
                { d: "2026-08-01", v: 54 },
                { d: "2026-09-01", v: 59 },
                { d: "2026-10-01", v: 41 },
              ],
            },
            {
              key: "vans",
              label: "Vans",
              color: "#B388FF",
              points: [
                { d: "2024-01-01", v: 80 },
                { d: "2024-02-01", v: 81 },
                { d: "2024-03-01", v: 88 },
                { d: "2024-04-01", v: 88 },
                { d: "2024-05-01", v: 87 },
                { d: "2024-06-01", v: 87 },
                { d: "2024-07-01", v: 95 },
                { d: "2024-08-01", v: 100 },
                { d: "2024-09-01", v: 83 },
                { d: "2024-10-01", v: 77 },
                { d: "2024-11-01", v: 85 },
                { d: "2024-12-01", v: 87 },
                { d: "2025-01-01", v: 72 },
                { d: "2025-02-01", v: 71 },
                { d: "2025-03-01", v: 78 },
                { d: "2025-04-01", v: 78 },
                { d: "2025-05-01", v: 75 },
                { d: "2025-06-01", v: 77 },
                { d: "2025-07-01", v: 84 },
                { d: "2025-08-01", v: 89 },
                { d: "2025-09-01", v: 83 },
                { d: "2025-10-01", v: 71 },
                { d: "2025-11-01", v: 85 },
                { d: "2025-12-01", v: 83 },
                { d: "2026-01-01", v: 74 },
                { d: "2026-02-01", v: 83 },
                { d: "2026-03-01", v: 86 },
                { d: "2026-04-01", v: 93 },
                { d: "2026-05-01", v: 88 },
                { d: "2026-06-01", v: 82 },
                { d: "2026-07-01", v: 90 },
                { d: "2026-08-01", v: 97 },
                { d: "2026-09-01", v: 89 },
                { d: "2026-10-01", v: 72 },
              ],
            },
          ],
        },
        {
          kind: "cohorts",
          insight:
            "Your record scores you highest on the names you borrow and lowest on the rooms you open, and the crowd reads you the other way round. Three times this year it describes a community that runs itself on rented platforms, with no space you run and no sound you own. The scene has the room and the music. You have the boot.",
          title: "Where your record scores you",
          provenance: "measured",
          note: "Six of the parts of your published score, from your latest run, on one scale. Collabs, campaigns, events and experiences score the plays you make. Brand codes and community score the brand itself, read three times this year. Tap a row for what sits under it.",
          open: "community",
          rows: [
            {
              id: "collab",
              label: "Collabs",
              context: "the names you borrow",
              score: 96,
              drivers: [
                "Your highest score, on twenty-two plays this year",
                "The crowd reads them coldest of anything you make, at plus seventeen",
                "The band licences read plus one, your coldest rebellion lane",
              ],
            },
            {
              id: "content",
              label: "Campaigns",
              context: "the stories you tell",
              score: 93,
              drivers: [
                "Eighteen plays this year, second only to collabs",
                "The crowd reads them at plus twenty-four, colder than the rooms",
              ],
            },
            {
              id: "codes",
              label: "Brand codes",
              context: "the stitch, the sole, the heel loop",
              score: 74,
              drivers: [
                "Up from seventy in January to seventy-four in August",
                "The yellow stitch, the grooved sole and the heel loop have held since 1960",
                "Sound is your weakest code in every read. The scene has the music",
              ],
            },
            {
              id: "community",
              label: "Community",
              context: "the crowd, read three times this year",
              score: 68,
              drivers: [
                "Every read names your boot a shorthand for alternative identity across scenes",
                "A crowd that runs itself on Reddit, TikTok and the resale market",
                "Its rituals are the break-in, the customising and the debate over where the boot is made",
                "Every read marks the same gap, no forum, no club and no space of your own",
              ],
            },
            {
              id: "event",
              label: "Events",
              context: "the nights and shows you put on",
              score: 46,
              drivers: [
                "Twelve plays this year, and half of them were never read",
                "The free canal party with a London crew read fifty-three",
                "The Specials in Camden was never read",
              ],
            },
            {
              id: "experience",
              label: "Experiences",
              context: "the rooms and spaces you open",
              score: 21,
              drivers: [
                "Your lowest score, on six plays this year",
                "The crowd reads them warmest of anything you make, at plus thirty",
                "Brewer Street, your one owned room, read forty",
                "The canal takeover read fifty-three on one of your lowest grades",
              ],
            },
          ],
        },
        {
          kind: "arena",
          insight:
            "You spend your rebellion where it reads coldest. Seventeen of the thirty-two plays in these lanes borrow a band's or a designer's name, and they read plus one and plus eighteen. The nights and the young makers read plus forty and plus forty-seven on the lowest grades you give anything. The one lane with no dot is causes, and the young trust a brand there least.",
          title: "Your rebellion lanes",
          provenance: "measured",
          unit: "strength of the play · 0–100",
          note: "Every rebellion play on your record since January, by lane, on one scale. Bands are the board's range on that lane, typical to ceiling. The ring is the field's strongest play there and the dots are yours. Received is the best presence the crowd gave any play on the lane. The tinted lanes are where the moves build. Tap a lane for the read.",
          rows: [
            {
              id: "heritage-bands",
              label: "Heritage bands",
              sub: "Metallica, Nine Inch Nails, The Specials",
              typical: 38,
              ceiling: 41,
              best: {
                brandName: "Adidas",
                title: "Original Forever",
                pts: 53,
              },
              received: 87,
              own: [
                { title: "Nine Inch Nails, The Downward Spiral", pts: 40 },
                { title: "Metallica campaign", pts: 39 },
                { title: "Metallica collection", pts: 34 },
                { title: "The Specials in Camden", pts: 32 },
              ],
              note: "Four plays, three read, plus one on average, the coldest lane on your record. Metallica was argued with in its first two windows. Adidas reads plus forty-five here on nine.",
            },
            {
              id: "designers",
              label: "Underground designers",
              sub: "Rick Owens, Supreme, Margiela",
              typical: 38,
              ceiling: 43,
              best: {
                brandName: "Adidas",
                title: "Rick Owens × Adidas ClimaCool SS27 tracksuits",
                pts: 57,
              },
              received: 73,
              own: [
                { title: "Rick Owens, June", pts: 47 },
                { title: "Rick Owens FW26", pts: 44 },
                { title: "Supreme 4-hole", pts: 43 },
                { title: "MM6 Margiela 1460", pts: 41 },
                { title: "Supreme Postal", pts: 41 },
                { title: "Rick Owens Megalace", pts: 40 },
                { title: "Wasted Youth Penton loafer", pts: 40 },
                { title: "Futura Laboratories 1460", pts: 38 },
                { title: "Supreme snakeskin Postal", pts: 34 },
                { title: "fragment design Hollingborn", pts: 34 },
                { title: "fragment design Hollingborn, 2026", pts: 34 },
                { title: "Wacko Maria campaign", pts: 31 },
                { title: "A-COLD-WALL*", pts: 25 },
              ],
              note: "Thirteen plays, the board's most, nine read, plus eighteen. The best read on your record sits here, Rick Owens in February at seventy-three, and the same designer made a rival's tracksuits in June.",
            },
            {
              id: "scene-nights",
              label: "Scene nights",
              sub: "parties, gigs, a canal boat",
              typical: 30,
              ceiling: 37,
              best: {
                brandName: "Adidas",
                title: "Home of Soccer night with PinkPantheress",
                pts: 44,
              },
              received: 73,
              own: [
                { title: "Barry Keoghan at the Vanity Fair party", pts: 36 },
                { title: "RICETTE, the NABA show", pts: 36 },
                { title: "The Specials in Camden", pts: 32 },
                { title: "The canal party", pts: 26 },
                { title: "Life on Loud", pts: 25 },
                { title: "The canal takeover with City Daze", pts: 23 },
                { title: "A London night", pts: 22 },
                { title: "Music, workshops and stand-up", pts: 17 },
              ],
              status: "recommended",
              note: "Eight plays, four read, plus forty against the board's plus thirty. The canal party and Life on Loud read fifty-three on grades in the twenties.",
            },
            {
              id: "young-makers",
              label: "Young makers",
              sub: "art students, first films",
              typical: 32,
              ceiling: 37,
              best: {
                brandName: "Nike",
                title: "HBCU Swingman Classic",
                pts: 48,
              },
              received: 80,
              own: [
                { title: "RICETTE, the NABA show", pts: 36 },
                { title: "Central Saint Martins alliance", pts: 26 },
                { title: "Girls in Film short", pts: 22 },
              ],
              status: "recommended",
              note: "Three plays, one read, at plus forty-seven, the art-school alliance. The board's craft schools read sixty-seven.",
            },
            {
              id: "pride",
              label: "Pride and identity",
              sub: "the artists' collection, the Pride boot",
              typical: 23,
              ceiling: 37,
              best: {
                brandName: "Gucci",
                title: "Gucci at the 2026 Met Gala",
                pts: 55,
              },
              received: 93,
              own: [
                { title: "LGBTQIA+ artists' collection", pts: 37 },
                { title: "Pride 1460", pts: 23 },
              ],
              note: "Two plays, both read, plus twenty-four. The collection made with artists read forty-seven and the rainbow boot read nothing.",
            },
            {
              id: "pop-licences",
              label: "Pop licences",
              sub: "cartoons, a gallery, a K-pop band",
              typical: 35,
              ceiling: 37,
              best: {
                brandName: "Adidas",
                title: "Adidas Originals × Brain Dead × Disney",
                pts: 42,
              },
              received: 80,
              own: [
                { title: "BT21 collection", pts: 39 },
                { title: "Powerpuff Girls, Heroes and Villains", pts: 36 },
                { title: "National Gallery collection", pts: 35 },
                { title: "Basquiat campaign", pts: 18 },
              ],
              note: "Four plays, two read, plus twenty-seven. The K-pop licence read fifty-three in Asia and the gallery read nothing.",
            },
            {
              id: "causes",
              label: "Causes and protest",
              sub: "no play on the record",
              typical: 31,
              ceiling: 33,
              best: {
                brandName: "Louis Vuitton",
                title: "Louis Vuitton × UNICEF Silver Lockit",
                pts: 38,
              },
              received: 67,
              note: "No play of yours. The board's cause plays are charity, a T-shirt and a bracelet, not protest. The lane where a brand reads most like the thing the young distrust.",
            },
          ],
        },
        {
          kind: "pairs",
          insight:
            "Your highest grades go to the names you borrow, and the crowd reads them least. The Rick Owens drop you graded highest was read at nothing, and the same designer made a rival's tracksuits this summer. The canal party, the art students and the artists' collection were graded in the twenties and thirties and read close to fifty. The crowd rewards the plays it can see itself in.",
          title: "Borrowed against made with",
          provenance: "measured",
          mode: "pair",
          a: { label: "Strength", color: "#FDE047" },
          b: { label: "Read", color: "#4ADE80" },
          note: "Eleven rebellion plays from your record, borrowed names first, then the plays made with a scene. Strength is the grade the play was given, read is the best presence the crowd gave it. A tail closes a row the crowd argued with. Tap a row for the read.",
          rows: [
            {
              id: "rick-owens-june",
              label: "Rick Owens, the June drop",
              sub: "a designer's name",
              a: 47,
              b: 0,
              note: "Your highest grade on any rebellion play, read twice at zero.",
            },
            {
              id: "mm6",
              label: "Margiela's MM6 1460",
              sub: "a designer's name",
              a: 41,
              b: 0,
              note: "Read twice, at zero both times.",
            },
            {
              id: "nine-inch-nails",
              label: "Nine Inch Nails",
              sub: "a band's name",
              a: 40,
              b: 0,
              note: "The album boot, read once at zero.",
            },
            {
              id: "metallica",
              label: "Metallica",
              sub: "a band's name",
              a: 34,
              b: 33,
              tail: "−7",
              tailLow: true,
              note: "Argued with at minus seven in its first two windows, then flat, then read at twenty-seven.",
            },
            {
              id: "supreme-postal",
              label: "Supreme's Postal",
              sub: "a label's name",
              a: 41,
              b: 53,
              note: "Read fifty-three in its first window and down to zero by its fifth.",
            },
            {
              id: "rick-owens-february",
              label: "Rick Owens, the February drop",
              sub: "a designer's name",
              a: 40,
              b: 73,
              note: "The best read on your record, seventy-three, and zero by its third window.",
            },
            {
              id: "artists-collection",
              label: "The LGBTQIA+ artists' collection",
              sub: "made with artists",
              a: 37,
              b: 47,
              note: "Three artists made it with you. Read forty-seven in its one window.",
            },
            {
              id: "brewer-street",
              label: "The Brewer Street room",
              sub: "a room you run",
              a: 39,
              b: 40,
              note: "Your one owned room, with a café and a bar, read forty.",
            },
            {
              id: "saint-martins",
              label: "Central Saint Martins",
              sub: "made with art students",
              a: 26,
              b: 47,
              note: "The alliance with the art school, read forty-seven on one of your lowest grades.",
            },
            {
              id: "canal-party",
              label: "The canal party",
              sub: "made with a London crew",
              a: 23,
              b: 53,
              note: "A free party on the canal with a London crew, read fifty-three.",
            },
            {
              id: "life-on-loud",
              label: "Life on Loud",
              sub: "a music campaign in America",
              a: 25,
              b: 53,
              note: "A music campaign with an American retailer, read fifty-three.",
            },
          ],
        },
        {
          kind: "quadrant",
          insight:
            "Opacity, the strategy of withholding, reads warmest on your record and you play it least. Four plays carry it, and they read fifteen points above your average. Fandom, the crowd that comes back, you have barely tried. Rebellion always kept something back, a room you had to find, and the moves are built on that.",
          title: "Which strategy rebellion answers",
          provenance: "measured",
          x: {
            label: "How often you play it",
            low: "rare",
            high: "often",
            hint: "plays carrying the strategy, as a share of identity's forty-six",
          },
          y: {
            label: "How the crowd reads it",
            low: "cooler",
            high: "warmer",
            hint: "average reception, with fifty as your average and each point of reception two steps",
          },
          quadrants: {
            tr: "Played and read",
            tl: "Read, rarely played",
            br: "Played, read less",
            bl: "Rare and cool",
          },
          note: "The five strategies on your record since January, placed by how often you play each and how the crowd reads it. Dot size is the number of plays, and the rare ones rest on three or four reads. The haloed dot is the strategy the moves are built on. Tap a dot for the read.",
          wLabel: "plays",
          open: "opacity",
          points: [
            {
              id: "identity",
              label: "Identity signal",
              color: "#FDE047",
              x: 97,
              y: 58,
              w: 46,
              status: "current",
              note: "Identity signal, the sign a crowd wears to say who it is. Forty-six plays, thirty-one read, plus twenty-six. Your default.",
            },
            {
              id: "aesthetic",
              label: "Aesthetic innovation",
              color: "#FB923C",
              x: 87,
              y: 60,
              w: 40,
              status: "current",
              note: "Aesthetic innovation, the new look. Forty plays, twenty-three read, plus twenty-seven.",
            },
            {
              id: "opacity",
              label: "Opacity",
              short: "the moves",
              color: "#B388FF",
              x: 9,
              y: 80,
              w: 4,
              status: "recommended",
              note: "Opacity, the strategy of withholding. Four plays, three read, plus thirty-seven, the warmest of the five. The room you have to find.",
            },
            {
              id: "scarcity",
              label: "Scarcity",
              color: "#60A5FA",
              x: 9,
              y: 38,
              w: 4,
              note: "Scarcity, the drop you have to be there for. Four plays, three read, plus sixteen, the coolest of the strategies you play.",
            },
            {
              id: "fandom",
              label: "Fandom",
              color: "#FF7AB8",
              x: 7,
              y: 6,
              w: 3,
              note: "Fandom, the crowd that comes back. Three plays, two read, both at zero. The strategy you have barely tried.",
            },
          ],
        },
        {
          kind: "cohorts",
          insight:
            "Four crowds still carry rebellion and one is the chapter closing. The pit is the room to host, the art schools are the hands to make it, queer nightlife already reads you, and the keepers rebel by refusing to buy new. The trend buyer the black boot rode on is the one walking away.",
          title: "The crowds that carry rebellion now",
          provenance: "projected",
          note: "Five crowds scored for how much of rebellion's next chapter each could carry, from the record's reads, your own year and this year's public data, and the clock each runs on. Tap a crowd for the drivers.",
          open: "hardcore",
          rows: [
            {
              id: "hardcore",
              label: "The pit and the platform boot",
              context: "hardcore, metal, the alt night",
              score: 88,
              role: "The room to host",
              horizon: "short",
              drivers: [
                "A free hardcore show drew sixty thousand people this autumn",
                "Seven in ten at one city's hardcore shows are twenty-one or under",
                "The black platform boot is the scene's uniform, and nobody names the maker",
                "Your scene nights read plus forty, above the board's thirty",
              ],
            },
            {
              id: "makers",
              label: "The art-school makers",
              context: "students, first collections, zines",
              score: 80,
              role: "The hands to make it",
              horizon: "long",
              drivers: [
                "Your art-school alliance read plus forty-seven on a grade of twenty-six",
                "Seven in ten young people say human-made culture matters more as AI spreads",
                "The young listen to a friend twenty-five times more often than to a famous face",
              ],
            },
            {
              id: "queer",
              label: "Queer nightlife",
              context: "the artists, the club, Pride past June",
              score: 72,
              role: "The scene that already reads you",
              horizon: "short",
              drivers: [
                "The artists' collection read plus forty-seven and the rainbow boot read nothing",
                "A rival paired Pride with a donation this summer",
                "Only two other brands on the board play the lane",
              ],
            },
            {
              id: "keepers",
              label: "The keep-it crowd",
              context: "repair, resale, the break-in",
              score: 70,
              role: "The quiet rebel",
              horizon: "long",
              drivers: [
                "Every community read names the break-in and the customising",
                "Four in ten of your resale buyers are new to you",
                "Two in three young Americans call big companies a threat",
              ],
            },
            {
              id: "style",
              label: "The trend buyer",
              context: "the black boot at its peak",
              score: 40,
              role: "The chapter closing",
              horizon: "short",
              drivers: [
                "Your boots fell eight percent last year",
                "Outside the teen top ten this autumn",
                "October search for your name fell from twenty to fourteen in two years",
              ],
            },
          ],
        },
        {
          kind: "matrix",
          insight:
            "The board plays rebellion through nights and makers, and nobody plays it the way you do. You hold the most designer collabs on the board and read them coolest. The rebel sneakers went two ways this year. One turned to sport, one cast a punk drummer and a hardcore bassist, and both are shrinking. Your empty cells are nights at scale and the makers.",
          title: "Who else plays rebellion",
          provenance: "measured",
          note: "Rebellion plays since January by lane, the board from your record and three rebel brands beside it. Each column is scaled to its busiest brand, so in the Pride column, where two plays is the most, a single play reads fifty. Tap a cell for the plays.",
          cols: [
            "Heritage bands",
            "Designers",
            "Scene nights",
            "Young makers",
            "Pride",
            "Causes",
          ],
          rows: [
            {
              label: "Dr. Martens",
              cells: [
                {
                  v: 44,
                  note: "Four plays, three read, plus one. Metallica, Nine Inch Nails, The Specials.",
                },
                {
                  v: 100,
                  note: "Thirteen plays, the board's most, nine read, plus eighteen.",
                },
                {
                  v: 36,
                  note: "Eight plays, four read, plus forty. The canal party read fifty-three.",
                },
                {
                  v: 60,
                  note: "Three plays, one read. The art-school alliance read plus forty-seven.",
                },
                {
                  v: 100,
                  note: "Two plays, both read, plus twenty-four.",
                },
                { v: 0, note: "No play on the lane." },
              ],
            },
            {
              label: "Adidas",
              cells: [
                {
                  v: 100,
                  note: "Nine plays, eight read, plus forty-five. Bob Marley and Original Forever lead it.",
                },
                {
                  v: 77,
                  note: "Ten plays, six read, plus thirty-nine. Labrum, Simone Rocha, Temple of Skate.",
                },
                {
                  v: 100,
                  note: "Twenty-two plays, the board's most, fourteen read, plus thirty-two.",
                },
                {
                  v: 100,
                  note: "Five plays, four read, plus thirty.",
                },
                { v: 0, note: "No play on the lane." },
                { v: 0, note: "No play on the lane." },
              ],
            },
            {
              label: "Nike",
              cells: [
                { v: 11, note: "One play, not read yet." },
                {
                  v: 31,
                  note: "Four plays, three read, plus twenty-nine.",
                },
                {
                  v: 32,
                  note: "Seven plays, three read, plus forty-nine, the warmest of the busy brands.",
                },
                {
                  v: 60,
                  note: "Three plays, one read, plus forty-seven.",
                },
                { v: 0, note: "No play on the lane." },
                { v: 0, note: "No play on the lane." },
              ],
            },
            {
              label: "UGG",
              cells: [
                { v: 11, note: "One play, not read yet." },
                { v: 8, note: "One play, read at zero." },
                {
                  v: 36,
                  note: "Eight plays, five read, plus twenty-eight.",
                },
                { v: 40, note: "Two plays, one read, at zero." },
                { v: 0, note: "No play on the lane." },
                { v: 0, note: "No play on the lane." },
              ],
            },
            {
              label: "Uniqlo",
              cells: [
                { v: 0, note: "No play on the lane." },
                { v: 0, note: "No play on the lane." },
                { v: 9, note: "Two plays, one read, plus fourteen." },
                {
                  v: 100,
                  note: "Five plays, one read, plus eighteen.",
                },
                { v: 0, note: "No play on the lane." },
                {
                  v: 100,
                  note: "Six plays, four read, plus forty-six. Charity T-shirts, not protest.",
                },
              ],
            },
            {
              label: "Chanel",
              cells: [
                { v: 0, note: "No play on the lane." },
                { v: 0, note: "No play on the lane." },
                { v: 5, note: "One play, read at zero." },
                {
                  v: 100,
                  note: "Five plays, four read, plus forty-five.",
                },
                { v: 0, note: "No play on the lane." },
                { v: 0, note: "No play on the lane." },
              ],
            },
            {
              label: "Lululemon",
              cells: [
                { v: 0, note: "No play on the lane." },
                { v: 0, note: "No play on the lane." },
                { v: 18, note: "Four plays, three read, plus five." },
                {
                  v: 40,
                  note: "Two plays, both read, plus seventeen.",
                },
                {
                  v: 100,
                  note: "Two plays, both read, plus twenty. A Pride collection and its campaign.",
                },
                { v: 0, note: "No play on the lane." },
              ],
            },
            {
              label: "Gucci",
              cells: [
                { v: 0, note: "No play on the lane." },
                { v: 8, note: "One play, not read yet." },
                { v: 5, note: "One play, read plus thirty-seven." },
                { v: 0, note: "No play on the lane." },
                {
                  v: 50,
                  note: "One play, the Met Gala, read plus eighty-seven.",
                },
                { v: 0, note: "No play on the lane." },
              ],
            },
            {
              label: "Vans",
              cells: [
                {
                  v: 11,
                  note: "One campaign this spring cast a pop star, a punk drummer and a hardcore bassist to sell misfits and malcontents.",
                },
                { v: 0, note: "No move found on the lane." },
                {
                  v: 5,
                  note: "The touring punk festival carrying its name, five stops this year.",
                },
                { v: 0, note: "No move found on the lane." },
                { v: 0, note: "No move found on the lane." },
                { v: 0, note: "No move found on the lane." },
              ],
            },
            {
              label: "Diesel",
              cells: [
                { v: 0, note: "No move found on the lane." },
                {
                  v: 0,
                  note: "No move found on the lane. Its creative director left in September.",
                },
                { v: 0, note: "No move found on the lane." },
                { v: 0, note: "No move found on the lane." },
                {
                  v: 50,
                  note: "A Pride capsule with a dating app this summer.",
                },
                {
                  v: 17,
                  note: "Two hundred thousand dollars from the capsule to an LGBTQ rights group.",
                },
              ],
            },
            {
              label: "Converse",
              cells: [
                {
                  v: 0,
                  note: "No move found on the lane. A new chief executive turned the brand to sport this year.",
                },
                { v: 0, note: "No move found on the lane." },
                { v: 0, note: "No move found on the lane." },
                { v: 0, note: "No move found on the lane." },
                { v: 0, note: "No move found on the lane." },
                { v: 0, note: "No move found on the lane." },
              ],
            },
          ],
        },
        {
          kind: "plays",
          insight:
            "Three moves, one for each crowd that still carries rebellion. Each one is a room or a pair the scene makes its own, and none of them says the word. The brand hosts, the scene books, makes and keeps.",
          title: "Three moves, priced",
          provenance: "projected",
          plays: [
            {
              name: "Basement 39, free all-ages hardcore and punk nights in the room under your Brewer Street store, booked by the city's own promoters, phones pouched at the door and nothing streamed, then the same night in your New York and Los Angeles brand centres",
              itemType: "experience",
              window:
                "Winter 2027, a night every fortnight in London, New York and Los Angeles by summer",
              strategies: [
                { code: "opacity", fit: 0.8 },
                { code: "identity_signal", fit: 0.5 },
              ],
              why: "The pit is young again and your boot is its uniform, but no brand is in the room. Your nights read plus forty on the lowest grades you give anything, and opacity, the strategy of withholding, reads warmest on your record. A room the scene books itself is rebellion you host without saying the word.",
              effect: {
                label: "CIQ",
                delta: 1.0,
                series: [0, 0.35, 0.65, 0.9, 1.0],
              },
              precedents: 3,
              reception:
                "the canal party graded 23 and read 53, your scene nights read +40 against the board's +30, and experience is your lowest-scored item type at 21",
              similar: [
                {
                  brand: "valentino",
                  brandName: "Valentino",
                  title: "Valentino Beauty House Party Pop-Up",
                  pts: 35.8,
                },
                {
                  brand: "adidas",
                  brandName: "Adidas",
                  title: "Adidas Originals × ASOS Collection 03 launch party",
                  pts: 29.0,
                },
              ],
            },
            {
              name: "The Scene Edition, one 1460 a season made with a young DIY scene chosen by open call, the collective's name on the heel loop and a share of every pair to the independent venue it plays",
              itemType: "collab",
              window:
                "Autumn 2027, the first edition with a London hardcore collective, the second from Tokyo",
              strategies: [
                { code: "identity_signal", fit: 0.7 },
                { code: "fandom", fit: 0.6 },
              ],
              why: "Your borrowed names read plus eighteen and the plays made with a scene read plus forty-seven. The young trust a friend over a famous face and value what a person made. Your heel loop has carried another name before. Handing it to a scene's own makers turns a collab into proof, and the money keeps open the rooms the scene needs.",
              effect: {
                label: "CIQ",
                delta: 0.8,
                series: [0, 0.3, 0.55, 0.75, 0.8],
              },
              precedents: 3,
              reception:
                "the artists' collection graded 37 and read 47, the art-school alliance read 47, and your thirteen designer collabs read +18",
              similar: [
                {
                  brand: "adidas",
                  brandName: "Adidas",
                  title: "Temple of Skate × Adidas capsule",
                  pts: 33.1,
                },
                {
                  brand: "adidas",
                  brandName: "Adidas",
                  title: "Labrum × Adidas Originals for END.",
                  pts: 28.0,
                },
              ],
            },
            {
              name: "The Resole Club, free repair, customising and break-in nights in your upgraded brand centres, a card that logs each pair's life, and the pairs you take back passed on through your resale shop",
              itemType: "experience",
              window:
                "Spring 2027, the first upgraded brand centres, then every one",
              strategies: [
                { code: "fandom", fit: 0.8 },
                { code: "identity_signal", fit: 0.4 },
              ],
              why: "Every community read on your record names the break-in and the customising, and none finds a space you run. Young Americans call big companies a threat and keep what they own longer. A boot kept for twenty years is the quietest rebellion you sell, and four in ten of your resale buyers are new to you.",
              effect: {
                label: "CIQ",
                delta: 0.6,
                series: [0, 0.25, 0.45, 0.55, 0.6],
              },
              precedents: 2,
              reception:
                "your Brewer Street room graded 39 and read 40, and the board's craft schools read 67",
              similar: [
                {
                  brand: "hermes",
                  brandName: "Hermès",
                  title: "Skills Academy in Japan, Metal Learning summer class",
                  pts: 35.3,
                },
                {
                  brand: "valentino",
                  brandName: "Valentino",
                  title: "Accademia Costume e Moda × Maison Valentino",
                  pts: 28.0,
                },
              ],
            },
          ],
          footnote:
            "Projected effects are priced on your measured record and the public facts in the file header, and compound with your current course.",
        },
        {
          kind: "impact",
          title: "What the three moves carry",
          provenance: "projected",
          delta: 2.4,
          body: "Close to two and a half points on your published score, from 65.39 to roughly 67.8, past Saint Laurent and level with Hermès. The comparison that matters is on your own shelf. The plays made with a scene read twice as warm as the names you borrow. The qualifier is the room itself. If the brand books the bands, it is another campaign, and the young read that first.",
        },
        {
          kind: "modelView",
          body: "Your record says the rebel slogan has run out. What it does not show is a brand that lost its rebels. The scenes still wear your boot without saying your name, and every read of your community finds a crowd that organises itself without you. The tell is on your own shelf. The plays you made with a scene read warm on small grades, and the names you borrowed read cold on big ones.\n\nWhat can be read at your scale is the direction, not the size. Each warm lane rests on a handful of plays, and one staged night would undo it. The rival sneakers that sell rebellion as a message are shrinking, and the young trust brands less than anyone, so the risk sits in saying it, not in doing it.\n\nSo build rooms and hand them over. Let the scene book the night, make the boot and keep the pair. Do not call any of it rebellion, and do not chase a cause the crowd did not bring you. The record reads a brand by the company it keeps.",
        },
      ],
    },
    {
      id: "communities-next",
      // which scenes Docs should join and serve next. An identity question on
      // the community type; the lead move is a home of its own
      itemType: "community",
      type: "community",
      question: "Which communities should Dr. Martens belong to next?",
      aliases: [
        "which scenes will wear docs after punk and goth",
        "which communities could make docs matter again",
        "which communities should docs belong to next",
        "what communities should dr martens join",
        "where does dr martens belong next",
        "which crowds should dr martens build with",
        "who is the next dr martens community",
        "which scenes should docs be part of next",
        "dr martens community strategy",
        "what comes after punk for dr martens",
      ],
      askedOn: "2026-11-02",
      blocks: [
        {
          kind: "readout",
          provenance: "measured",
          verdict:
            "Your record still calls your community the alternative crowd that adopted you, and when you re-tell that story through its bands it reads coldest. The communities that read you warmest are the ones you open a room for: the gig crowd, the anime and k-pop fan in Asia, and the craft crowd who break in, repair and resell their boots.",
        },
        {
          kind: "stats",
          provenance: "observed",
          insight:
            "The money already follows the crowds that read you warmest. Shoes and resale grow while boots fall, and Asia Pacific pays full price faster than any region. The business is moving toward the craft crowd and the fan in Asia before your community story does.",
          items: [
            {
              label: "Shoes, share of revenue",
              value: "31%",
              hint: "This year's full results. Shoes rose from about a quarter of the business while boots fell. The buyer is no longer only the boot crowd.",
            },
            {
              label: "Asia Pacific, full price",
              value: "+15%",
              hint: "Full-price direct sales across Asia Pacific this year, the fastest of any region. The fan the record reads warmest already pays full price.",
            },
            {
              label: "The US, full price",
              value: "+14%",
              hint: "Full-price direct sales in the US this year, while Europe fell on heavy promotion.",
            },
            {
              label: "US resale",
              value: "+73%",
              hint: "Growth of your own resale programme in the US this year. The craft crowd keeps pairs in circulation.",
            },
          ],
        },
        {
          kind: "shift",
          insight:
            "The new crowds are asking for a room. Young adults want events that connect them, the small venues are full and broke, and fans dress to belong. The scene is far bigger than the brand inside it. The last row is the lesson. A fandom courted from outside turns in days.",
          title: "What the new crowds are doing",
          provenance: "observed",
          note: "Six public numbers from the past year. Each line says what the figure counts and why it is here. The last one is the risk, not a signal.",
          rows: [
            {
              label: "Want events with their community",
              context:
                "Young adults in the US and UK who want events that connect them to their community, in a survey of four thousand people aged eighteen to thirty-five published this January. The crowd is asking for the room.",
              value: "89%",
            },
            {
              label: "Small venue visits, the UK",
              context:
                "Growth in audience visits to the UK's small independent music venues last year, to about twenty-one million, while more than half of those venues made no profit. The rooms are full and broke.",
              value: "+13%",
            },
            {
              label: "Dressing like the artist",
              context:
                "Gen Z concert-goers in Australia who say dressing like the artist is central to going. Clothes are how a fan belongs.",
              value: "86%",
            },
            {
              label: "An animated k-pop film",
              context:
                "Views of an animated k-pop film in its first half year on streaming, the biggest title the platform has ever reported. The anime and k-pop fan is the largest crowd in culture right now.",
              value: "482m",
            },
            {
              label: "#goth against #drmartens",
              context:
                "Posts tagged goth on TikTok against posts tagged with your name, as read this week. The scene is far bigger than the brand inside it.",
              value: "50×",
            },
            {
              label: "A rival's k-pop ad",
              context:
                "A rival's k-pop sneaker ad came down within two weeks this September after critics condemned its imagery. A fandom courted from outside can turn in days.",
              value: "Withdrawn",
            },
          ],
        },
        {
          kind: "trendCompare",
          insight:
            "The scene you came from is growing, not fading. Punk climbed by more than a third in two years, the search for repairing a shoe did the same, and anime conventions rose by half. The scene night as a search barely moved. The crowds are out there, and they look for places and for things that last.",
          title: "Where the search went",
          provenance: "observed",
          note: "Worldwide Google search interest for four terms, monthly means from January 2024 to October 2026 on one scale. The busiest month of any of them reads 100. emo night, the ghost, is the scene night as a search, flat for three years.",
          highlight: {
            from: "2026-04-01",
            to: "2026-06-30",
            label: "Repair and conventions peak",
          },
          series: [
            {
              key: "shoe-repair",
              label: "shoe repair",
              color: "#FDE047",
              points: [
                {
                  d: "2024-01-01",
                  v: 52,
                },
                {
                  d: "2024-02-01",
                  v: 51,
                },
                {
                  d: "2024-03-01",
                  v: 50,
                },
                {
                  d: "2024-04-01",
                  v: 50,
                },
                {
                  d: "2024-05-01",
                  v: 50,
                },
                {
                  d: "2024-06-01",
                  v: 50,
                },
                {
                  d: "2024-07-01",
                  v: 48,
                },
                {
                  d: "2024-08-01",
                  v: 51,
                },
                {
                  d: "2024-09-01",
                  v: 51,
                },
                {
                  d: "2024-10-01",
                  v: 52,
                },
                {
                  d: "2024-11-01",
                  v: 53,
                },
                {
                  d: "2024-12-01",
                  v: 56,
                },
                {
                  d: "2025-01-01",
                  v: 53,
                },
                {
                  d: "2025-02-01",
                  v: 50,
                },
                {
                  d: "2025-03-01",
                  v: 50,
                },
                {
                  d: "2025-04-01",
                  v: 50,
                },
                {
                  d: "2025-05-01",
                  v: 50,
                },
                {
                  d: "2025-06-01",
                  v: 51,
                },
                {
                  d: "2025-07-01",
                  v: 57,
                },
                {
                  d: "2025-08-01",
                  v: 62,
                },
                {
                  d: "2025-09-01",
                  v: 64,
                },
                {
                  d: "2025-10-01",
                  v: 64,
                },
                {
                  d: "2025-11-01",
                  v: 68,
                },
                {
                  d: "2025-12-01",
                  v: 63,
                },
                {
                  d: "2026-01-01",
                  v: 64,
                },
                {
                  d: "2026-02-01",
                  v: 62,
                },
                {
                  d: "2026-03-01",
                  v: 68,
                },
                {
                  d: "2026-04-01",
                  v: 100,
                },
                {
                  d: "2026-05-01",
                  v: 89,
                },
                {
                  d: "2026-06-01",
                  v: 78,
                },
                {
                  d: "2026-07-01",
                  v: 57,
                },
                {
                  d: "2026-08-01",
                  v: 59,
                },
                {
                  d: "2026-09-01",
                  v: 70,
                },
                {
                  d: "2026-10-01",
                  v: 55,
                },
              ],
            },
            {
              key: "punk-rock",
              label: "punk rock",
              color: "#FB923C",
              points: [
                {
                  d: "2024-01-01",
                  v: 41,
                },
                {
                  d: "2024-02-01",
                  v: 43,
                },
                {
                  d: "2024-03-01",
                  v: 43,
                },
                {
                  d: "2024-04-01",
                  v: 42,
                },
                {
                  d: "2024-05-01",
                  v: 45,
                },
                {
                  d: "2024-06-01",
                  v: 39,
                },
                {
                  d: "2024-07-01",
                  v: 39,
                },
                {
                  d: "2024-08-01",
                  v: 40,
                },
                {
                  d: "2024-09-01",
                  v: 41,
                },
                {
                  d: "2024-10-01",
                  v: 43,
                },
                {
                  d: "2024-11-01",
                  v: 43,
                },
                {
                  d: "2024-12-01",
                  v: 42,
                },
                {
                  d: "2025-01-01",
                  v: 38,
                },
                {
                  d: "2025-02-01",
                  v: 41,
                },
                {
                  d: "2025-03-01",
                  v: 41,
                },
                {
                  d: "2025-04-01",
                  v: 42,
                },
                {
                  d: "2025-05-01",
                  v: 46,
                },
                {
                  d: "2025-06-01",
                  v: 39,
                },
                {
                  d: "2025-07-01",
                  v: 52,
                },
                {
                  d: "2025-08-01",
                  v: 53,
                },
                {
                  d: "2025-09-01",
                  v: 50,
                },
                {
                  d: "2025-10-01",
                  v: 49,
                },
                {
                  d: "2025-11-01",
                  v: 48,
                },
                {
                  d: "2025-12-01",
                  v: 51,
                },
                {
                  d: "2026-01-01",
                  v: 51,
                },
                {
                  d: "2026-02-01",
                  v: 80,
                },
                {
                  d: "2026-03-01",
                  v: 54,
                },
                {
                  d: "2026-04-01",
                  v: 65,
                },
                {
                  d: "2026-05-01",
                  v: 65,
                },
                {
                  d: "2026-06-01",
                  v: 58,
                },
                {
                  d: "2026-07-01",
                  v: 59,
                },
                {
                  d: "2026-08-01",
                  v: 55,
                },
                {
                  d: "2026-09-01",
                  v: 56,
                },
                {
                  d: "2026-10-01",
                  v: 45,
                },
              ],
            },
            {
              key: "anime-convention",
              label: "anime convention",
              color: "#60A5FA",
              points: [
                {
                  d: "2024-01-01",
                  v: 9,
                },
                {
                  d: "2024-02-01",
                  v: 9,
                },
                {
                  d: "2024-03-01",
                  v: 10,
                },
                {
                  d: "2024-04-01",
                  v: 10,
                },
                {
                  d: "2024-05-01",
                  v: 11,
                },
                {
                  d: "2024-06-01",
                  v: 10,
                },
                {
                  d: "2024-07-01",
                  v: 12,
                },
                {
                  d: "2024-08-01",
                  v: 12,
                },
                {
                  d: "2024-09-01",
                  v: 9,
                },
                {
                  d: "2024-10-01",
                  v: 8,
                },
                {
                  d: "2024-11-01",
                  v: 7,
                },
                {
                  d: "2024-12-01",
                  v: 7,
                },
                {
                  d: "2025-01-01",
                  v: 9,
                },
                {
                  d: "2025-02-01",
                  v: 9,
                },
                {
                  d: "2025-03-01",
                  v: 10,
                },
                {
                  d: "2025-04-01",
                  v: 11,
                },
                {
                  d: "2025-05-01",
                  v: 12,
                },
                {
                  d: "2025-06-01",
                  v: 12,
                },
                {
                  d: "2025-07-01",
                  v: 14,
                },
                {
                  d: "2025-08-01",
                  v: 17,
                },
                {
                  d: "2025-09-01",
                  v: 13,
                },
                {
                  d: "2025-10-01",
                  v: 12,
                },
                {
                  d: "2025-11-01",
                  v: 12,
                },
                {
                  d: "2025-12-01",
                  v: 12,
                },
                {
                  d: "2026-01-01",
                  v: 13,
                },
                {
                  d: "2026-02-01",
                  v: 13,
                },
                {
                  d: "2026-03-01",
                  v: 16,
                },
                {
                  d: "2026-04-01",
                  v: 16,
                },
                {
                  d: "2026-05-01",
                  v: 20,
                },
                {
                  d: "2026-06-01",
                  v: 20,
                },
                {
                  d: "2026-07-01",
                  v: 20,
                },
                {
                  d: "2026-08-01",
                  v: 16,
                },
                {
                  d: "2026-09-01",
                  v: 13,
                },
                {
                  d: "2026-10-01",
                  v: 8,
                },
              ],
            },
            {
              key: "emo-night",
              label: "emo night",
              color: "#A78BFA",
              ghost: true,
              points: [
                {
                  d: "2024-01-01",
                  v: 9,
                },
                {
                  d: "2024-02-01",
                  v: 10,
                },
                {
                  d: "2024-03-01",
                  v: 10,
                },
                {
                  d: "2024-04-01",
                  v: 9,
                },
                {
                  d: "2024-05-01",
                  v: 8,
                },
                {
                  d: "2024-06-01",
                  v: 8,
                },
                {
                  d: "2024-07-01",
                  v: 8,
                },
                {
                  d: "2024-08-01",
                  v: 8,
                },
                {
                  d: "2024-09-01",
                  v: 8,
                },
                {
                  d: "2024-10-01",
                  v: 8,
                },
                {
                  d: "2024-11-01",
                  v: 8,
                },
                {
                  d: "2024-12-01",
                  v: 8,
                },
                {
                  d: "2025-01-01",
                  v: 9,
                },
                {
                  d: "2025-02-01",
                  v: 9,
                },
                {
                  d: "2025-03-01",
                  v: 9,
                },
                {
                  d: "2025-04-01",
                  v: 8,
                },
                {
                  d: "2025-05-01",
                  v: 7,
                },
                {
                  d: "2025-06-01",
                  v: 7,
                },
                {
                  d: "2025-07-01",
                  v: 8,
                },
                {
                  d: "2025-08-01",
                  v: 9,
                },
                {
                  d: "2025-09-01",
                  v: 9,
                },
                {
                  d: "2025-10-01",
                  v: 9,
                },
                {
                  d: "2025-11-01",
                  v: 7,
                },
                {
                  d: "2025-12-01",
                  v: 8,
                },
                {
                  d: "2026-01-01",
                  v: 10,
                },
                {
                  d: "2026-02-01",
                  v: 11,
                },
                {
                  d: "2026-03-01",
                  v: 9,
                },
                {
                  d: "2026-04-01",
                  v: 8,
                },
                {
                  d: "2026-05-01",
                  v: 8,
                },
                {
                  d: "2026-06-01",
                  v: 7,
                },
                {
                  d: "2026-07-01",
                  v: 8,
                },
                {
                  d: "2026-08-01",
                  v: 8,
                },
                {
                  d: "2026-09-01",
                  v: 9,
                },
                {
                  d: "2026-10-01",
                  v: 8,
                },
              ],
            },
          ],
        },
        {
          kind: "cohorts",
          insight:
            "The record rates your community eighth on the board, under your own brand codes, and describes it the same way all year, an alternative identity worn on the stitch and earned in the break-in. Every read marks the same gap, a community with no home of its own. None names the rooms or the fan in Asia, where the crowd reads you warmest.",
          title: "How the record rates your community",
          provenance: "measured",
          note: "The latest community read for the nine highest of the nineteen brands on the board, on one scale, yours marked. Tap a brand for its community plays this year. Tap yours for what your three reads say.",
          open: "dr-martens",
          rows: [
            {
              id: "hermes",
              label: "Hermès",
              context: "craft, repair and music",
              score: 89,
              drivers: [
                "Twenty-three craft and repair plays this year, read plus forty-four",
                "Four band plays read plus forty-five, where yours read plus one",
                "Its DJ console graded thirty-eight and read seventy-three",
              ],
            },
            {
              id: "nike",
              label: "Nike",
              context: "the rooms and the fan gathering",
              score: 89,
              drivers: [
                "Ten nights and rooms this year, read plus thirty-three",
                "A fan gathering in Portland graded twenty-three and read seventy-three",
                "Seventeen craft and repair plays",
              ],
            },
            {
              id: "chanel",
              label: "Chanel",
              context: "craft and the k-pop fan",
              score: 80,
              drivers: [
                "Fourteen craft and repair plays this year, read plus forty-three",
                "Three anime and k-pop plays, read plus fifty-four",
              ],
            },
            {
              id: "adidas",
              label: "adidas",
              context: "the most rooms on the board",
              score: 78,
              drivers: [
                "Twenty-two nights and rooms this year, more than any brand on the board",
                "Thirty-two craft and repair plays, also the most",
                "Its anime and k-pop plays read plus fifty-six",
              ],
            },
            {
              id: "prada",
              label: "Prada",
              context: "the travelling club",
              score: 75,
              drivers: [
                "Prada Mode in New York graded fifty-seven and read seventy-three",
              ],
            },
            {
              id: "lululemon",
              label: "Lululemon",
              context: "the run festival",
              score: 73,
              drivers: [
                "SeaWheeze, its run festival, graded twenty-one and read seventy-three",
                "The only other brand on the board with pride plays",
              ],
            },
            {
              id: "louis-vuitton",
              label: "Louis Vuitton",
              context: "rooms and the k-pop fan",
              score: 72,
              drivers: [
                "Thirteen nights and rooms this year, read plus forty-seven",
                "Three anime and k-pop plays, read plus forty-five",
              ],
            },
            {
              id: "dr-martens",
              label: "Dr. Martens",
              context: "eighth of nineteen, under your brand codes",
              score: 68,
              own: true,
              drivers: [
                "Every read names a shared alternative identity, rooted in decades of music and subculture",
                "The crowd wears the stitch and trades break-in rituals on Reddit and TikTok",
                "Every read marks the same gap, no community home of your own",
                "No read names the rooms or the fan in Asia, where the crowd reads you warmest",
                "Your brand codes read seventy-four, above the community that wears them",
              ],
            },
            {
              id: "dior",
              label: "Dior",
              context: "rooms, an exhibition, the k-pop tour",
              score: 67,
              drivers: [
                "Seventeen nights and rooms this year, read plus thirty",
                "An exhibition at an art school's museum graded thirty and read eighty",
                "Its tour with Jimin read fifty-three",
              ],
            },
          ],
        },
        {
          kind: "arena",
          insight:
            "The grader rates you highest where you borrow, on the runway and with the street labels, and the crowd reads you warmest where you host. The rooms you opened are the lowest graded lane on your record and the best received.",
          title: "Your community lanes",
          provenance: "measured",
          unit: "strength of the play · 0–100",
          note: "Every community play on your record since January, by lane, on one scale. Bands are the board's range on that lane, typical to ceiling. The ring is the field's strongest play there and the dots are yours. Received is the best presence the crowd gave any play on the lane. The tinted lanes are where the moves build. Tap a lane for the read.",
          rows: [
            {
              id: "rooms",
              label: "Rooms & nights",
              sub: "the store, the gig, the party",
              typical: 29,
              ceiling: 37,
              best: {
                brandName: "Hermès",
                title: "Hermès Disque Jockey Club",
                pts: 38,
              },
              received: 80,
              own: [
                {
                  title: "Concept store, Doctor's Orders Café",
                  pts: 39,
                },
                {
                  title: "Brewer Street concept store",
                  pts: 37,
                },
                {
                  title: "Canal Takeover Party with City Daze",
                  pts: 23,
                },
                {
                  title: "Beacon store and Brand Centre",
                  pts: 22,
                },
              ],
              status: "recommended",
              note: "Nine plays graded lowest of any lane and read warmest, plus thirty-six. The beacon store graded twenty-two and the crowd read it at eighty. The canal party read fifty-three twice.",
            },
            {
              id: "anime",
              label: "Anime, k-pop & characters",
              sub: "Tokyo, Seoul, the fan club",
              typical: 36,
              ceiling: 41,
              best: {
                brandName: "Dior",
                title: "Dior × Jimin, the ARIRANG tour",
                pts: 34,
              },
              received: 93,
              own: [
                {
                  title: "BT21 collection",
                  pts: 39,
                },
                {
                  title: "LiSA, 15 Years Journey",
                  pts: 37,
                },
                {
                  title: "Powerpuff Girls, Heroes and Villains",
                  pts: 36,
                },
                {
                  title: "Wataru Komachi Tokyo show",
                  pts: 32,
                },
              ],
              status: "recommended",
              note: "Seven plays read plus thirty-five. BT21 read fifty-three and LiSA forty. Gucci and adidas read this crowd warmer on a few more plays.",
            },
            {
              id: "craft",
              label: "Craft & repair",
              sub: "Made in England, the collector",
              typical: 34,
              ceiling: 39,
              best: {
                brandName: "Valentino",
                title: "Valentino Rockstud reworked",
                pts: 37,
              },
              received: 93,
              own: [
                {
                  title: "1461 Made in England, Sepia Grey",
                  pts: 42,
                },
                {
                  title: "Retro Mod 3-eyelet, Cherry Red",
                  pts: 36,
                },
                {
                  title: "8065 Mary Jane",
                  pts: 32,
                },
                {
                  title: "Quilon leather, Made in England",
                  pts: 28,
                },
              ],
              status: "recommended",
              note: "Fourteen plays read plus twenty-nine. The Mary Jane read seventy-three, the Retro Mod sixty-seven. The collector the assessments describe answers every reissue.",
            },
            {
              id: "bands",
              label: "Heritage bands",
              sub: "punk, metal, 2-tone",
              typical: 35,
              ceiling: 38,
              received: 80,
              own: [
                {
                  title: "Nine Inch Nails, The Downward Spiral",
                  pts: 40,
                },
                {
                  title: "Metallica campaign",
                  pts: 39,
                },
                {
                  title: "Metallica collection",
                  pts: 34,
                },
              ],
              note: "Seven plays read plus one, the coldest lane on your record. Nine Inch Nails read zero and Metallica thirty-three at best. The brands that borrow the scene read plus thirty-three to forty-nine on it.",
            },
            {
              id: "art",
              label: "Art & art school",
              sub: "the gallery, the student",
              typical: 28,
              ceiling: 34,
              best: {
                brandName: "Dior",
                title: "Dior, Crafting Fashion at SCAD FASH",
                pts: 30,
              },
              received: 80,
              own: [
                {
                  title: "NABA, RICETTE show",
                  pts: 36,
                },
                {
                  title: "National Gallery",
                  pts: 35,
                },
                {
                  title: "Central Saint Martins alliance",
                  pts: 26,
                },
              ],
              note: "Your busiest lane, seventeen plays, read plus eleven. The art school alliance read forty-seven.",
            },
            {
              id: "street",
              label: "Japan & street insiders",
              sub: "BEAMS, Supreme, the drop",
              typical: 38,
              ceiling: 40,
              received: 67,
              own: [
                {
                  title: "Supreme 4-hole",
                  pts: 43,
                },
                {
                  title: "Supreme Postal",
                  pts: 41,
                },
                {
                  title: "BEAMS Lowell, Crazy Pattern",
                  pts: 40,
                },
              ],
              note: "A lane you hold almost alone, fifteen plays graded high and read plus twelve. Supreme's Postal read fifty-three and fell to zero over five windows.",
            },
            {
              id: "pride",
              label: "Queer & pride",
              sub: "the crowd to earn",
              typical: 22,
              ceiling: 27,
              best: {
                brandName: "Lululemon",
                title: "Lululemon Pride collection",
                pts: 22,
              },
              received: 67,
              own: [
                {
                  title: "LGBTQIA+ artists' collection",
                  pts: 37,
                },
                {
                  title: "1460 Pride boot",
                  pts: 23,
                },
              ],
              note: "Two plays. The artists' collection read forty-seven, the donation boot zero. A lane to earn with the scene's own makers, never a logo for one month.",
            },
            {
              id: "western",
              label: "Western & rodeo",
              sub: "the desert, the ranch",
              typical: 34,
              ceiling: 37,
              received: 53,
              own: [
                {
                  title: "Desert Rodeo Collection",
                  pts: 27,
                },
              ],
              note: "One play, read forty-seven. Too few to call a lane.",
            },
          ],
        },
        {
          kind: "pairs",
          insight:
            "The bands that made your name are the coldest thing you do now. Seven band collections this year read barely above neutral. Nine nights and stores you hosted read warmer than anything else on your record.",
          title: "Plays against reads, lane by lane",
          provenance: "measured",
          mode: "pair",
          a: {
            label: "Plays",
            color: "#FDE047",
          },
          b: {
            label: "Read",
            color: "#4ADE80",
          },
          note: "Your community plays since January, lane by lane. Plays is the count, read is the crowd's average net reception across every window it read them. Tap a row for the read.",
          rows: [
            {
              id: "rooms",
              label: "Rooms & nights",
              sub: "the store, the party",
              a: 9,
              b: 36,
              note: "Seven read, plus thirty-six, the warmest lane on your record.",
            },
            {
              id: "anime",
              label: "Anime, k-pop & characters",
              sub: "the fan club",
              a: 7,
              b: 35,
              note: "Five read, plus thirty-five, with BT21 at fifty-three.",
            },
            {
              id: "craft",
              label: "Made in England craft",
              sub: "the collector",
              a: 14,
              b: 29,
              note: "Nine read, plus twenty-nine. The reissue the collector waits for.",
            },
            {
              id: "western",
              label: "Western & rodeo",
              sub: "one play",
              a: 1,
              b: 34,
              note: "One play read, plus thirty-four. Too few to call.",
            },
            {
              id: "pride",
              label: "Queer & pride",
              sub: "two plays",
              a: 2,
              b: 24,
              note: "Two read, plus twenty-four. The artists read warmer than the donation boot.",
            },
            {
              id: "women",
              label: "Women & girls",
              sub: "the Mary Jane, the film",
              a: 8,
              b: 22,
              note: "Five read, plus twenty-two.",
            },
            {
              id: "runway",
              label: "Designer runway",
              sub: "Rick Owens, MM6",
              a: 11,
              b: 20,
              note: "Five read, plus twenty, on the highest grades of any lane.",
            },
            {
              id: "street",
              label: "Japan & street insiders",
              sub: "BEAMS, Supreme",
              a: 15,
              b: 12,
              note: "Nine read, plus twelve. Busy and cool.",
            },
            {
              id: "art",
              label: "Art & art school",
              sub: "the gallery",
              a: 17,
              b: 11,
              note: "Nine read, plus eleven. Your busiest lane and one of the coolest.",
            },
            {
              id: "bands",
              label: "Heritage bands",
              sub: "punk, metal, 2-tone",
              a: 7,
              b: 1,
              note: "Four read, plus one. The founding story, re-told, and the coldest read on the record.",
            },
          ],
        },
        {
          kind: "pairs",
          insight:
            "The plays graded highest read coldest, and the plays graded lowest read warmest. The grader notices a drop with a famous name. People notice a night in a room.",
          title: "Hosted for them, sold to them",
          provenance: "measured",
          mode: "pair",
          a: {
            label: "Grade",
            color: "#FDE047",
          },
          b: {
            label: "Reception",
            color: "#4ADE80",
          },
          note: "Ten community plays from your record. Grade is the play's measured strength, reception its best read window. Tap a row for the read.",
          rows: [
            {
              id: "beacon",
              label: "Beacon store and Brand Centre",
              sub: "hosted · a room",
              a: 22,
              b: 80,
              note: "Graded twenty-two, the crowd read it at eighty. The widest gap between grade and read on your record.",
            },
            {
              id: "canal",
              label: "Canal Takeover Party",
              sub: "hosted · with City Daze",
              a: 23,
              b: 53,
              note: "A free party on the canal, read fifty-three in the play and again in its press.",
            },
            {
              id: "brewer",
              label: "Brewer Street concept store",
              sub: "hosted · a room",
              a: 37,
              b: 47,
              note: "Read forty-seven in its first window.",
            },
            {
              id: "mary-jane",
              label: "8065 Mary Jane",
              sub: "craft · a reissue",
              a: 32,
              b: 73,
              note: "Read sixty, thirteen, twenty-six, then seventy-three at its best. The collector came back for it.",
            },
            {
              id: "bt21",
              label: "BT21 collection",
              sub: "fans · Asia Pacific",
              a: 39,
              b: 53,
              note: "Read fifty-three in its first window.",
            },
            {
              id: "lisa",
              label: "LiSA, 15 Years Journey",
              sub: "fans · Asia Pacific",
              a: 37,
              b: 40,
              note: "Read zero, then forty as her fans found it.",
            },
            {
              id: "metallica",
              label: "Metallica collection",
              sub: "a band · sold",
              a: 34,
              b: 33,
              note: "Read minus seven twice, then zero, then twenty-seven.",
            },
            {
              id: "mm6",
              label: "MM6 Maison Margiela 1460 Twist",
              sub: "a designer · sold",
              a: 41,
              b: 0,
              note: "Read twice, zero both times.",
            },
            {
              id: "nin",
              label: "Nine Inch Nails, The Downward Spiral",
              sub: "a band · sold",
              a: 40,
              b: 0,
              note: "Graded forty and read at zero.",
            },
            {
              id: "rick-owens",
              label: "Rick Owens, the June drop",
              sub: "a designer · sold",
              a: 47,
              b: 0,
              note: "The highest-graded play on your record, read zero twice.",
            },
          ],
        },
        {
          kind: "pairs",
          insight:
            "You are not choosing the wrong strategy. The crowd reads you below the field on almost every one, by thirteen to seventeen points where you play most. The difference is whether the crowd was in the room when you made it.",
          title: "Your reads against the field's, strategy by strategy",
          provenance: "measured",
          mode: "pair",
          a: {
            label: "You",
            color: "#FDE047",
          },
          b: {
            label: "The field",
            color: "#4ADE80",
          },
          note: "Average reception on community plays since January, yours against the rest of the fashion board. Fandom is the crowd that comes back, scarcity the limited drop, opacity the strategy of withholding. Your last three rest on one or two reads each. Tap a row for the read.",
          rows: [
            {
              id: "aesthetic",
              label: "Aesthetic innovation",
              sub: "the new look",
              a: 28,
              b: 41,
              note: "Twenty-four plays, fourteen read. Fourteen points under the field.",
            },
            {
              id: "identity",
              label: "Identity signal",
              sub: "the sign worn",
              a: 24,
              b: 40,
              note: "Twenty-four plays, fifteen read. Sixteen points under the field.",
            },
            {
              id: "fandom",
              label: "Fandom",
              sub: "the crowd that comes back",
              a: 0,
              b: 40,
              note: "Two plays, both read cold. The field brings it on eighty-five community plays.",
            },
            {
              id: "scarcity",
              label: "Scarcity",
              sub: "the limited drop",
              a: 0,
              b: 42,
              note: "Two plays, both read cold.",
            },
            {
              id: "opacity",
              label: "Opacity",
              sub: "withholding",
              a: 53,
              b: 35,
              note: "One play read, at fifty-three. Too few to call a habit.",
            },
          ],
        },
        {
          kind: "cohorts",
          insight:
            "Three crowds could carry what you mean next, and none of them is the one your story names first. The craft crowd already shapes your sales, the small room reads you warmest, and the fan in Asia pays full price. The punk faithful are alive and read your re-tellings cold.",
          title: "The crowds that could carry it",
          provenance: "projected",
          note: "Five crowds scored for how much of your next chapter each could carry, modelled from the record's lanes, your own results and this year's public data, with the clock each runs on. Tap a crowd for the drivers.",
          open: "craft",
          rows: [
            {
              id: "craft",
              label: "The craft crowd",
              context: "who break in, repair and resell their boots",
              score: 84,
              role: "The home the record says is missing",
              horizon: "long",
              drivers: [
                "Your Made in England reissues read plus twenty-nine on fourteen plays, best seventy-three on the Mary Jane",
                "Every community read this year names the break-in or the debate over how the boots are made",
                "Your US resale programme grew seventy-three percent this year, and craft-minded buyers are a record share of your customers",
                "The search for repairing a shoe rose by more than a third in two years",
              ],
            },
            {
              id: "rooms",
              label: "The small-room crowd",
              context: "gigs, readings, cyphers, comedy",
              score: 80,
              role: "The warmest read",
              horizon: "short",
              drivers: [
                "Your hosted nights and stores read plus thirty-six, the warmest lane on your record",
                "The beacon store read eighty and sells at prices about fifteen percent above your other London stores",
                "Nine in ten young adults want events that connect them to their community",
                "The UK's small venues drew thirteen percent more visits last year and most made no profit",
              ],
            },
            {
              id: "anime",
              label: "The anime and k-pop fan in Asia",
              context: "Tokyo, Seoul, the fan club",
              score: 76,
              role: "Already paying full price",
              horizon: "short",
              drivers: [
                "Anime, k-pop and character plays read plus thirty-five on seven, best fifty-three on BT21",
                "Asia Pacific full-price sales grew fifteen percent this year, your fastest region",
                "Japan and Korea are performing well by your own account this summer",
                "Anime convention search rose by half in two years",
              ],
            },
            {
              id: "punk",
              label: "The punk and metal faithful",
              context: "alive on search, borrowed by rivals",
              score: 58,
              role: "Your past, read cold when re-told",
              horizon: "long",
              drivers: [
                "Seven band collections read plus one, the coldest lane on your record",
                "Punk search rose by more than a third in two years",
                "A sportswear giant ran a mosh-pit race and released an Ozzy pair",
                "The brands that borrow the scene read plus thirty-three to forty-nine on it",
              ],
            },
            {
              id: "style",
              label: "The style seeker",
              context: "the buyer of the black-boot peak",
              score: 48,
              role: "The buyer you chased",
              horizon: "short",
              drivers: [
                "You are in no top ten of this autumn's teen survey, where Timberland entered and Birkenstock gained most with girls",
                "Absent from every quarterly ranking of fashion's hottest brands this year",
                "Boots fell eight percent this year while shoes grew",
              ],
            },
          ],
        },
        {
          kind: "matrix",
          insight:
            "The scene you came from has new tenants. A sportswear giant ran a mosh-pit race and a skate brand brought back its punk tour. The small room and the repair bench belong to the biggest brand on the board and to nobody in boots. Those are the two communities still open to you.",
          title: "Who holds which community",
          provenance: "projected",
          note: "Cell brightness is a modelled hold of each community, zero to a hundred, from each brand's plays on the record scaled to the busiest brand on the column, and from this year's public moves where a brand has no record. A single play on a quiet column is a step, not a lead. Tap a cell for the read.",
          cols: [
            "Punk & metal",
            "Small rooms & nights",
            "Anime & k-pop",
            "Craft & repair",
            "Designer pairs",
          ],
          rows: [
            {
              label: "Dr. Martens",
              cells: [
                {
                  v: 100,
                  note: "Seven band plays, the board's most, read plus one, the coldest on the column.",
                },
                {
                  v: 27,
                  note: "Six plays on the board's count, read plus thirty-six, with the beacon store at eighty.",
                },
                {
                  v: 30,
                  note: "Three plays on the board's count, read plus fifty.",
                },
                {
                  v: 47,
                  note: "Fifteen plays, read plus thirty-three.",
                },
                {
                  v: 70,
                  note: "Eleven designer plays graded highest of your lanes and read plus twenty. Rick Owens fell from seventy-three to zero.",
                },
              ],
            },
            {
              label: "Adidas",
              cells: [
                {
                  v: 71,
                  note: "Five plays read plus thirty-three, a mosh-pit race and an Ozzy pair this year.",
                },
                {
                  v: 100,
                  note: "Twenty-two hosted plays, the board's most, read plus thirty-three.",
                },
                {
                  v: 70,
                  note: "Seven plays read plus fifty-six.",
                },
                {
                  v: 100,
                  note: "Thirty-two plays on resale, vintage and reissue, the board's most.",
                },
                {
                  v: 20,
                  note: "Designer lines on trainers, not boots.",
                },
              ],
            },
            {
              label: "UGG",
              cells: [
                {
                  v: 15,
                  note: "A biker boot with Willy Chavarria, a rebel's shape with no band behind it.",
                },
                {
                  v: 27,
                  note: "Six plays read plus thirty.",
                },
                {
                  v: 0,
                  note: "No play found on the lane.",
                },
                {
                  v: 0,
                  note: "No play found on the lane.",
                },
                {
                  v: 75,
                  note: "The Chavarria debut read eighty, a boot-maker on a designer's stage in Paris.",
                },
              ],
            },
            {
              label: "Jacquemus",
              cells: [
                {
                  v: 0,
                  note: "No play found on the lane.",
                },
                {
                  v: 40,
                  note: "Its Beach Club in Monte-Carlo read seventy-three, a room the house hosts.",
                },
                {
                  v: 0,
                  note: "No play found on the lane.",
                },
                {
                  v: 0,
                  note: "No play found on the lane.",
                },
                {
                  v: 80,
                  note: "Its Timberland 3-Eye Lug read eighty in its first window.",
                },
              ],
            },
            {
              label: "Gucci",
              cells: [
                {
                  v: 0,
                  note: "No play found on the lane.",
                },
                {
                  v: 0,
                  note: "No hosted night found on the lane.",
                },
                {
                  v: 50,
                  note: "Five plays read plus sixty-three, the warmest on the column.",
                },
                {
                  v: 0,
                  note: "No play found on the lane.",
                },
                {
                  v: 0,
                  note: "No pair with an outside shoemaker found.",
                },
              ],
            },
            {
              label: "Birkenstock",
              cells: [
                {
                  v: 0,
                  note: "No move found on the lane.",
                },
                {
                  v: 0,
                  note: "No move found on the lane.",
                },
                {
                  v: 0,
                  note: "No move found on the lane.",
                },
                {
                  v: 55,
                  note: "It limits supply by design, and its closed shoes, the Boston clog first, are a growing share of its sales.",
                },
                {
                  v: 65,
                  note: "A designer pair with sacai on the runway this year.",
                },
              ],
            },
            {
              label: "Timberland",
              cells: [
                {
                  v: 0,
                  note: "No move found on the lane.",
                },
                {
                  v: 10,
                  note: "Its new partnership is motorsport, a racing series, not a room.",
                },
                {
                  v: 0,
                  note: "No move found on the lane.",
                },
                {
                  v: 0,
                  note: "No move found on the lane.",
                },
                {
                  v: 80,
                  note: "Designer pairs with Jacquemus and Louis Vuitton, and in the teen top ten for the first time this autumn.",
                },
              ],
            },
            {
              label: "Converse",
              cells: [
                {
                  v: 0,
                  note: "No move found on the lane, with sales down twenty-eight percent this summer.",
                },
                {
                  v: 0,
                  note: "No move found on the lane.",
                },
                {
                  v: 20,
                  note: "Its k-pop ad came down within two weeks this September.",
                },
                {
                  v: 0,
                  note: "No move found on the lane.",
                },
                {
                  v: 0,
                  note: "No move found on the lane.",
                },
              ],
            },
          ],
        },
        {
          kind: "plays",
          insight:
            "Three rooms of your own, one for each crowd that reads you warmest. Each is built on fandom, the crowd that comes back, the strategy your record almost never brings. None of them signs a band to prove the past.",
          title: "Three moves, priced",
          provenance: "projected",
          plays: [
            {
              name: "The Break-In Club, a membership kept in the beacon stores and online: break-in nights, a resoling and customising bench, the Made in England factory open to members, and every member's pair logged for repair and resale",
              itemType: "experience",
              window: "January to April 2027, the season's new pairs",
              strategies: [
                {
                  code: "fandom",
                  fit: 0.7,
                },
                {
                  code: "identity_signal",
                  fit: 0.6,
                },
              ],
              why: "Every community read this year marks the same gap, a crowd with no home of its own, and names the same ritual, the break-in. The craft crowd already answers every reissue and keeps pairs in circulation. The club gives the community the home the record says is missing.",
              effect: {
                label: "CIQ",
                delta: 1,
                series: [0, 0.35, 0.65, 0.9, 1],
              },
              precedents: 3,
              reception:
                "your craft reissues read +29 on fourteen plays, best 73 on the Mary Jane, with the Retro Mod at 67 and the Quilon at 60",
              similar: [
                {
                  brand: "dior",
                  brandName: "Dior",
                  title: "Dior, Crafting Fashion at SCAD FASH",
                  pts: 29.5,
                },
                {
                  brand: "valentino",
                  brandName: "Valentino",
                  title: "Valentino Rockstud reworked",
                  pts: 36.8,
                },
              ],
            },
            {
              name: "Back Room Sessions, nights you host in small independent venues in London, Manchester, Paris, Munich, New York and Los Angeles, curated by the local scene with dub poetry, cyphers, punk and emo bills and comedy, the door money going to the venue",
              itemType: "event",
              window: "February to May 2027, one night a month per city",
              strategies: [
                {
                  code: "aesthetic_innovation",
                  fit: 0.6,
                },
                {
                  code: "fandom",
                  fit: 0.6,
                },
                {
                  code: "identity_signal",
                  fit: 0.4,
                },
              ],
              why: "Belong to the gig, not the band. Your hosted rooms read warmer than anything else on the record while the band collections read barely above neutral. The small venues are full and losing money, and a brand that keeps their doors open earns a place in the room.",
              effect: {
                label: "CIQ",
                delta: 0.9,
                series: [0, 0.3, 0.55, 0.8, 0.9],
              },
              precedents: 3,
              reception:
                "your hosted rooms read +36 on nine plays, best 80 on the beacon store, against +1 for the band collections",
              similar: [
                {
                  brand: "hermes",
                  brandName: "Hermès",
                  title: "Hermès Disque Jockey Club",
                  pts: 38.1,
                },
                {
                  brand: "valentino",
                  brandName: "Valentino",
                  title: "Valentino Beauty House Party",
                  pts: 35.8,
                },
              ],
            },
            {
              name: "Yellow Stitch Club, a fan chapter with one J-rock or anime artist, run from the Tokyo showroom and the Seoul flagship, with members' pairs, fan meet-ups and the artist's fans as co-designers",
              itemType: "collab",
              window: "April to July 2027, convention season",
              strategies: [
                {
                  code: "fandom",
                  fit: 0.8,
                },
                {
                  code: "aesthetic_innovation",
                  fit: 0.5,
                },
                {
                  code: "scarcity",
                  fit: 0.3,
                },
              ],
              why: "The fan in Asia reads you warm and already pays full price in your fastest region. A fan club is a community that already exists. Build the chapter with the fans and never cast it at them, because a fandom courted from outside turns in days.",
              effect: {
                label: "CIQ",
                delta: 0.7,
                series: [0, 0.25, 0.45, 0.6, 0.7],
              },
              precedents: 2,
              reception:
                "anime, k-pop and character plays read +35 on seven, best 53 on BT21, with LiSA's anniversary pair at 40",
              similar: [
                {
                  brand: "uniqlo",
                  brandName: "Uniqlo",
                  title: "Uniqlo UT × G-Dragon's ZO&FRIENDS",
                  pts: 33.3,
                },
                {
                  brand: "chanel",
                  brandName: "Chanel",
                  title: "Chanel × Karina in Vogue Korea",
                  pts: 26,
                },
                {
                  brand: "dior",
                  brandName: "Dior",
                  title: "Dior × Jimin, the ARIRANG tour",
                  pts: 34.2,
                },
              ],
            },
          ],
          footnote:
            "Projected effects are priced on your measured record and the public facts in the file header, and compound with your current course.",
        },
        {
          kind: "impact",
          title: "What the three moves carry",
          provenance: "projected",
          delta: 2.6,
          body: "Three rooms of your own add about two and a half points to your published score, from 65.39 to roughly 68.0, past Saint Laurent and Hermès and a point short of Gucci. The craft club carries the most because it gives the community the home every reading says it lacks. The caution is scale. Every warm lane reads on under ten plays, so this is the direction, not the size.",
        },
        {
          kind: "modelView",
          body: "The community is real and it has not changed its name. Every reading this year describes the alternative crowd that adopted you, and every one says you have never given it a home. The tell is on your own record. You are read best where you host and worst where you license your own past, and your company has already called the rebellious story too narrow.\n\nWhat can be read at your scale is the direction, not the size. Your record holds under a hundred plays, and each warm lane rests on a handful. The rooms, the fan in Asia and the craft crowd point the same way, and one cold season could undo any of them alone. What the record reads with confidence is the shape. The plays made in a room with the crowd read far above their grade, and the famous names sold to it read nothing.\n\nSo build the home the community has lived without. Open the club, host the nights, give the fans a chapter of their own. Do not call it a loyalty programme, and do not sign another band to prove the past. A crowd adopts a boot when the boot shows up where it already is.",
        },
      ],
    },
    {
      id: "next-hotspot-store",
      // a store opening is an experience shelf. The answer is a format and a
      // place, not a door count: Roma as a beacon, São Paulo as a pop-up
      itemType: "experience",
      type: "retail",
      question: "Which cultural hotspot gets our next store?",
      aliases: [
        "whats the next cultural hotspot where dr martens should open a store",
        "what is the next cultural hotspot where dr martens should open a store",
        "where should we open our next store",
        "which citys scene is ready for a dr martens store",
        "which city scene is ready for a dr martens store",
        "where should dr martens open its next store",
        "which cultural hotspot should get our next store",
        "where is the next cultural hotspot for our store",
        "which city should get our next store",
        "where should our next beacon store be",
      ],
      askedOn: "2026-11-02",
      blocks: [
        {
          kind: "readout",
          provenance: "observed",
          verdict:
            "Roma in Mexico City is your next hotspot, and your partner's first store there is already on its way. Open it as your first beacon outside London, not a shop that only sells boots, and test São Paulo with a pop-up before anyone signs a lease.",
        },
        {
          kind: "stats",
          provenance: "observed",
          insight:
            "The scene is already in Mexico City and still growing, and the format you built in London earns more on every pair. The question is the kind of door you open, not how many.",
          items: [
            {
              label: "Emo in Mexico",
              value: "2×",
              hint: "Streams of emo and pop-punk in Mexico doubled in six years. The music your boot grew up with finds a bigger crowd here every year.",
            },
            {
              label: "Latin music",
              value: "+17.1%",
              hint: "Recorded-music revenue across Latin America last year, the fastest growth of any region. The scene around a store here is still growing.",
            },
            {
              label: "Vive Latino",
              value: "160,000",
              hint: "Fans across two days of Mexico City's rock festival this spring. The region's scene gathers in one city.",
            },
            {
              label: "Beacon premium",
              value: "+15%",
              hint: "Your London beacon sells at an average price more than fifteen percent above your other London stores, on a smaller range. The format pays where the culture is.",
            },
          ],
        },
        {
          kind: "geoCompare",
          insight:
            "The scenes growing fastest are the ones where you have the fewest doors. Mexico City leads because the music is already there and your partner's store is on its way.",
          title: "Where the scene is ahead of your doors",
          provenance: "projected",
          metric: "Scene readiness",
          focus: "mexico-city",
          note: "Scene readiness blends music growth, this year's city rankings, where the scene brands opened and where you have no door. Modelled, not measured. Tap a city to read it against Mexico City.",
          markets: [
            {
              id: "mexico-city",
              label: "Mexico City · Roma",
              x: 23.1,
              y: 19.3,
              value: 86,
              delta: 9,
              note: "Emo streams have doubled, the city's rock festival drew a hundred and sixty thousand this spring, and your partner's store opens in Roma this winter. Two brands on the board have played the city. You have not.",
            },
            {
              id: "seoul",
              label: "Seoul",
              x: 87.7,
              y: 12.6,
              value: 84,
              delta: 2,
              note: "Your fastest-growing market this year and home of this year's coolest neighbourhood. You already run eighteen stores in Korea and a brand centre in Seoul.",
            },
            {
              id: "sao-paulo",
              label: "São Paulo · Barra Funda",
              x: 38.1,
              y: 35.0,
              value: 81,
              delta: 8,
              note: "A top-five nightlife city, and the rents on its fashion street rose faster than on any other in the world. You have no store, no partner and no play here.",
            },
            {
              id: "bangkok",
              label: "Bangkok",
              x: 80.1,
              y: 21.4,
              value: 77,
              delta: 4,
              note: "This year's top nightlife city and the world's most-visited. You sell in Thailand through five partner stores.",
            },
            {
              id: "tokyo",
              label: "Tokyo",
              x: 91.3,
              y: 13.3,
              value: 72,
              delta: 0,
              note: "Home of the old punk neighbourhood on this year's coolest list, and your densest market in Asia.",
            },
            {
              id: "london",
              label: "London",
              x: 51.4,
              y: 7.5,
              value: 68,
              delta: -3,
              note: "Your home, with Camden and the first beacon. Your stores across Europe sold eight percent less this year.",
            },
            {
              id: "new-york",
              label: "New York",
              x: 30.3,
              y: 11.5,
              value: 66,
              delta: 0,
              note: "You are turning your Herald Square store into a brand centre. The scene brands' openings here come with closures beside them, and Nike shut its SoHo flagship this year.",
            },
            {
              id: "lisbon",
              label: "Lisbon",
              x: 48.8,
              y: 12.2,
              value: 64,
              delta: -4,
              note: "You have no store here, and one of its neighbourhoods made this year's coolest list. Its own residents now rank the city thirty-seven places lower than last year.",
            },
          ],
        },
        {
          kind: "shift",
          insight:
            "The scene in Mexico is grown up and still growing. Over half of its emo listeners are past twenty-five, and the festivals pull the whole region into the city. The young are cooling on Mexico City, so the store has to win the fan past twenty-five first.",
          title: "What the scene is doing in Mexico",
          provenance: "observed",
          note: "Five public numbers from the past year. Each line says what the figure counts and why it is here. The last one is the risk, not a signal.",
          rows: [
            {
              label: "Emo listeners",
              context:
                "Growth in monthly listeners of emo and pop-punk in Mexico since 2022. The crowd your boot grew up with keeps growing here.",
              value: "+66%",
            },
            {
              label: "Who listens",
              context:
                "Share of emo streams in Mexico from listeners aged twenty-five to thirty-four. The buyer is the grown-up fan with money, not only the teenager.",
              value: "Over half",
            },
            {
              label: "Mexico's recorded music",
              context:
                "Growth in Mexico's recorded-music revenue last year, now the tenth-largest market in the world. The gigs around a Roma store have room to grow.",
              value: "+13.3%",
            },
            {
              label: "Festival crowd",
              context:
                "Share of the crowd at Mexico City's November indie festival that travels in from other cities and countries. A Roma store sells to the whole region in festival weeks.",
              value: "Over 40%",
            },
            {
              label: "Gen Z ranking",
              context:
                "Mexico City's place in this year's ranking of cities by people under thirty, down from last year. The young crowd is cooling on the city while the scene keeps growing.",
              value: "8th to 17th",
            },
          ],
        },
        {
          kind: "trendCompare",
          insight:
            "Your name has not caught up with the scene. Searches for it in Mexico are small and flat, the online launch did not move them, and the two sneaker icons are fading. A store that only sells will not change that. A store the scene uses will.",
          title: "Searches for heritage shoes in Mexico",
          provenance: "observed",
          note: "Google search interest in Mexico, monthly from January 2024 to October 2026, one comparative fetch, scaled so the busiest month of any line reads a hundred.",
          highlight: {
            from: "2026-09-01",
            to: "2026-10-01",
            label: "Online store opens",
          },
          series: [
            {
              key: "dr-martens",
              label: "Dr. Martens",
              color: "#a8475a",
              points: [
                { d: "2024-01-01", v: 10 },
                { d: "2024-02-01", v: 7 },
                { d: "2024-03-01", v: 7 },
                { d: "2024-04-01", v: 6 },
                { d: "2024-05-01", v: 6 },
                { d: "2024-06-01", v: 8 },
                { d: "2024-07-01", v: 10 },
                { d: "2024-08-01", v: 8 },
                { d: "2024-09-01", v: 8 },
                { d: "2024-10-01", v: 8 },
                { d: "2024-11-01", v: 10 },
                { d: "2024-12-01", v: 12 },
                { d: "2025-01-01", v: 8 },
                { d: "2025-02-01", v: 7 },
                { d: "2025-03-01", v: 7 },
                { d: "2025-04-01", v: 7 },
                { d: "2025-05-01", v: 6 },
                { d: "2025-06-01", v: 8 },
                { d: "2025-07-01", v: 10 },
                { d: "2025-08-01", v: 8 },
                { d: "2025-09-01", v: 7 },
                { d: "2025-10-01", v: 8 },
                { d: "2025-11-01", v: 11 },
                { d: "2025-12-01", v: 11 },
                { d: "2026-01-01", v: 8 },
                { d: "2026-02-01", v: 7 },
                { d: "2026-03-01", v: 7 },
                { d: "2026-04-01", v: 7 },
                { d: "2026-05-01", v: 6 },
                { d: "2026-06-01", v: 7 },
                { d: "2026-07-01", v: 6 },
                { d: "2026-08-01", v: 8 },
                { d: "2026-09-01", v: 8 },
                { d: "2026-10-01", v: 8 },
              ],
            },
            {
              key: "converse",
              label: "Converse",
              color: "#60A5FA",
              points: [
                { d: "2024-01-01", v: 100 },
                { d: "2024-02-01", v: 90 },
                { d: "2024-03-01", v: 92 },
                { d: "2024-04-01", v: 79 },
                { d: "2024-05-01", v: 81 },
                { d: "2024-06-01", v: 76 },
                { d: "2024-07-01", v: 86 },
                { d: "2024-08-01", v: 81 },
                { d: "2024-09-01", v: 72 },
                { d: "2024-10-01", v: 74 },
                { d: "2024-11-01", v: 92 },
                { d: "2024-12-01", v: 94 },
                { d: "2025-01-01", v: 67 },
                { d: "2025-02-01", v: 60 },
                { d: "2025-03-01", v: 54 },
                { d: "2025-04-01", v: 61 },
                { d: "2025-05-01", v: 65 },
                { d: "2025-06-01", v: 61 },
                { d: "2025-07-01", v: 60 },
                { d: "2025-08-01", v: 71 },
                { d: "2025-09-01", v: 50 },
                { d: "2025-10-01", v: 50 },
                { d: "2025-11-01", v: 65 },
                { d: "2025-12-01", v: 78 },
                { d: "2026-01-01", v: 53 },
                { d: "2026-02-01", v: 47 },
                { d: "2026-03-01", v: 51 },
                { d: "2026-04-01", v: 50 },
                { d: "2026-05-01", v: 49 },
                { d: "2026-06-01", v: 42 },
                { d: "2026-07-01", v: 50 },
                { d: "2026-08-01", v: 53 },
                { d: "2026-09-01", v: 42 },
                { d: "2026-10-01", v: 44 },
              ],
            },
            {
              key: "vans",
              label: "Vans",
              color: "#B388FF",
              points: [
                { d: "2024-01-01", v: 79 },
                { d: "2024-02-01", v: 75 },
                { d: "2024-03-01", v: 81 },
                { d: "2024-04-01", v: 69 },
                { d: "2024-05-01", v: 78 },
                { d: "2024-06-01", v: 72 },
                { d: "2024-07-01", v: 90 },
                { d: "2024-08-01", v: 89 },
                { d: "2024-09-01", v: 75 },
                { d: "2024-10-01", v: 69 },
                { d: "2024-11-01", v: 88 },
                { d: "2024-12-01", v: 96 },
                { d: "2025-01-01", v: 69 },
                { d: "2025-02-01", v: 58 },
                { d: "2025-03-01", v: 64 },
                { d: "2025-04-01", v: 69 },
                { d: "2025-05-01", v: 74 },
                { d: "2025-06-01", v: 67 },
                { d: "2025-07-01", v: 72 },
                { d: "2025-08-01", v: 69 },
                { d: "2025-09-01", v: 56 },
                { d: "2025-10-01", v: 57 },
                { d: "2025-11-01", v: 83 },
                { d: "2025-12-01", v: 94 },
                { d: "2026-01-01", v: 67 },
                { d: "2026-02-01", v: 64 },
                { d: "2026-03-01", v: 67 },
                { d: "2026-04-01", v: 64 },
                { d: "2026-05-01", v: 67 },
                { d: "2026-06-01", v: 54 },
                { d: "2026-07-01", v: 69 },
                { d: "2026-08-01", v: 82 },
                { d: "2026-09-01", v: 82 },
                { d: "2026-10-01", v: 56 },
              ],
            },
          ],
        },
        {
          kind: "openings",
          title: "Where the scene brands opened doors",
          provenance: "observed",
          insight:
            "The scene brands chose neighbourhoods over avenues. Seongsu is now the address everyone already has. Roma is the one still filling.",
          note: "Recent doors the brands that sell to scenes opened themselves. Filter by industry.",
          rows: [
            {
              brand: "salomon",
              brandName: "Salomon",
              industry: "footwear",
              city: "Mexico City",
              area: "Roma Norte",
              when: "2026-03-06",
              note: "First Latin American flagship",
            },
            {
              brand: "adidas",
              brandName: "Adidas Originals",
              industry: "sportswear",
              city: "São Paulo",
              area: "Pinheiros",
              when: "2025-11-17",
              note: "Customisation bar, café, mural",
            },
            {
              brand: "supreme",
              brandName: "Supreme",
              industry: "streetwear",
              city: "Seoul",
              area: "Seongsu",
              when: "2026-09-12",
              note: "Second store in Korea",
            },
            {
              brand: "dr-martens",
              brandName: "Dr. Martens",
              industry: "footwear",
              city: "Seoul",
              area: "Dosan Park",
              when: "2026-03-18",
              note: "Your first brand centre",
            },
            {
              brand: "palace",
              brandName: "Palace",
              industry: "streetwear",
              city: "Shanghai",
              area: "Zhangyuan",
              when: "2026-05-23",
              note: "First mainland China flagship",
            },
            {
              brand: "vans",
              brandName: "Vans",
              industry: "skate",
              city: "Milan",
              area: "Brera",
              when: "2026-07-24",
              note: "Events space, replaced a closed store",
            },
            {
              brand: "birkenstock",
              brandName: "Birkenstock",
              industry: "footwear",
              city: "Osaka",
              area: "Shinsaibashi",
              when: "2026-04-16",
            },
            {
              brand: "carhartt-wip",
              brandName: "Carhartt WIP",
              industry: "streetwear",
              city: "Lausanne",
              area: "Le Flon",
              when: "2025-12-04",
            },
          ],
        },
        {
          kind: "matrix",
          insight:
            "The board plays where the money already is. Two brands have played Mexico City and none São Paulo, and you are absent from both. The first brand the crowd reads there sets the bar.",
          title: "Who on the board plays where",
          provenance: "measured",
          note: "Plays naming each city since January, scaled to the busiest brand in each column. In Mexico City the busiest is two plays, so a hundred there is a step, not a crowd. São Paulo is blank for every brand. Tap a cell for the count.",
          cols: [
            "London",
            "Tokyo",
            "Seoul",
            "Bangkok",
            "Mexico City",
            "São Paulo",
          ],
          rows: [
            {
              label: "Dr. Martens",
              cells: [
                {
                  v: 100,
                  note: "Ten plays name London, the most of any brand on the board, your Brewer Street store and the canal party among them.",
                },
                {
                  v: 75,
                  note: "Three plays name Tokyo, the LiSA exhibition and anniversary night among them.",
                },
                {
                  v: 50,
                  note: "One play names Seoul, the beacon and brand centre formats.",
                },
                { v: 0, note: "No play names Bangkok." },
                { v: 0, note: "No play names Mexico City." },
                { v: 0, note: "No play names São Paulo." },
              ],
            },
            {
              label: "Nike",
              cells: [
                { v: 80, note: "Eight plays." },
                { v: 50, note: "Two plays." },
                { v: 0, note: "No play." },
                { v: 100, note: "Three plays, the most in the column." },
                {
                  v: 100,
                  note: "Two plays, the most any brand has made in Mexico City.",
                },
                { v: 0, note: "No play." },
              ],
            },
            {
              label: "Adidas",
              cells: [
                { v: 90, note: "Nine plays." },
                { v: 75, note: "Three plays." },
                { v: 100, note: "Two plays, level with the busiest." },
                {
                  v: 67,
                  note: "Two plays, the café collab in Song Wat among them.",
                },
                { v: 0, note: "No play." },
                { v: 0, note: "No play." },
              ],
            },
            {
              label: "Louis Vuitton",
              cells: [
                { v: 30, note: "Three plays." },
                { v: 25, note: "One play." },
                { v: 100, note: "Two plays, level with the busiest." },
                {
                  v: 100,
                  note: "Three plays, the exhibition LV The Place among them.",
                },
                { v: 0, note: "No play." },
                { v: 0, note: "No play." },
              ],
            },
            {
              label: "Dior",
              cells: [
                { v: 10, note: "One play." },
                { v: 100, note: "Four plays, the most in the column." },
                { v: 100, note: "Two plays, level with the busiest." },
                { v: 100, note: "Three plays, level with the busiest." },
                { v: 0, note: "No play." },
                { v: 0, note: "No play." },
              ],
            },
            {
              label: "Hermès",
              cells: [
                {
                  v: 90,
                  note: "Nine plays, the Maison on Bond Street among them.",
                },
                { v: 25, note: "One play." },
                { v: 50, note: "One play." },
                { v: 0, note: "No play." },
                { v: 0, note: "No play." },
                { v: 0, note: "No play." },
              ],
            },
            {
              label: "Chanel",
              cells: [
                { v: 70, note: "Seven plays." },
                { v: 50, note: "Two plays." },
                { v: 50, note: "One play." },
                { v: 0, note: "No play." },
                { v: 0, note: "No play." },
                { v: 0, note: "No play." },
              ],
            },
            {
              label: "Bottega Veneta",
              cells: [
                { v: 20, note: "Two plays." },
                { v: 25, note: "One play." },
                { v: 50, note: "One play." },
                { v: 100, note: "Three plays, level with the busiest." },
                { v: 0, note: "No play." },
                { v: 0, note: "No play." },
              ],
            },
            {
              label: "Giorgio Armani",
              cells: [
                { v: 10, note: "One play." },
                { v: 0, note: "No play." },
                { v: 0, note: "No play." },
                { v: 0, note: "No play." },
                { v: 50, note: "One play." },
                { v: 0, note: "No play." },
              ],
            },
          ],
        },
        {
          kind: "arena",
          insight:
            "You build stores above the board's ceiling and leave the cheapest test empty. A pop-up lets the crowd read the next city before you sign a lease.",
          title: "Your experience shelf against the board",
          provenance: "measured",
          unit: "strength of the play · 0–100",
          note: "Every experience play on the fashion board since January, by lane, on one scale. Bands run from typical to ceiling, the ring is the field's strongest play there and the dots are yours. Received is the best read the crowd gave any play in the lane. The tinted lane is where a move builds. Tap a lane for the read.",
          rows: [
            {
              id: "stores",
              label: "Stores",
              sub: "the door itself",
              typical: 23,
              ceiling: 32,
              best: {
                brandName: "Hermès",
                title: "Maison Bond Street, London",
                pts: 49,
              },
              received: 80,
              own: [
                { title: "Doctor's Orders concept store", pts: 39 },
                { title: "Brewer Street beacon", pts: 37 },
                { title: "Beacon and brand centre formats", pts: 22 },
              ],
              note: "Three plays, all three read. You graded your London stores above the board's ceiling, and the crowd read the beacon formats at eighty, the warmest read on your record.",
            },
            {
              id: "gigs",
              label: "Parties and gigs",
              sub: "the night out",
              typical: 30,
              ceiling: 34,
              best: {
                brandName: "Jacquemus",
                title: "Beach Club Takeover, Monte-Carlo",
                pts: 47,
              },
              received: 80,
              own: [{ title: "Canal Takeover Party", pts: 23 }],
              note: "One play, the canal party with a London crew. You graded it in the low twenties and the crowd read it at fifty-three.",
            },
            {
              id: "exhibitions",
              label: "Exhibitions",
              sub: "the archive on show",
              typical: 26,
              ceiling: 33,
              best: {
                brandName: "Louis Vuitton",
                title: "LV The Place Bangkok",
                pts: 53,
              },
              received: 80,
              own: [
                { title: "Rebels + Icons photography show", pts: 23 },
                { title: "LiSA special exhibition", pts: 20 },
              ],
              note: "Two plays. The crowd never read the photography show and read the LiSA exhibition at zero.",
            },
            {
              id: "popups",
              label: "Pop-ups",
              sub: "the test before a lease",
              typical: 25,
              ceiling: 30,
              best: {
                brandName: "Louis Vuitton",
                title: "Louis Vuitton Hotel London",
                pts: 49,
              },
              received: 80,
              status: "recommended",
              note: "No play of yours. A pop-up is the cheapest way to read a city before a lease, and the Barra Funda Garage builds here.",
            },
          ],
        },
        {
          kind: "pairs",
          insight:
            "Plays made in a real place read warmer than plays made from a famous name. Your band and designer collections launch stronger and land colder. A store that hosts the scene turns your music into somewhere to go.",
          title: "The place against the name",
          provenance: "measured",
          mode: "pair",
          a: { label: "Strength", color: "#FDE047" },
          b: { label: "Read", color: "#4ADE80" },
          note: "Seven plays from your record, the plays made in a place first, then the names. Strength is the grade at launch, read is the best presence the crowd gave it. A tail closes a row the crowd argued with. Music plays on the rest of the board read fifty on average, and yours read under thirty. Tap a row for the read.",
          rows: [
            {
              id: "brewer",
              label: "Brewer Street beacon",
              sub: "Soho, London",
              a: 37,
              b: 47,
              note: "Your concept store in Soho. The crowd read it at forty-seven in its first window.",
            },
            {
              id: "canal",
              label: "Canal party",
              sub: "Camden to Hackney Wick",
              a: 23,
              b: 53,
              note: "A free party on the canal with a London crew, read fifty-three on one of your lowest grades.",
            },
            {
              id: "formats",
              label: "Beacon and brand centre formats",
              sub: "London and Seoul",
              a: 22,
              b: 80,
              note: "The plan for beacons and brand centres, read eighty, the warmest read on your record.",
            },
            {
              id: "lisa",
              label: "LiSA 15 Years Journey",
              sub: "Harajuku, Tokyo",
              a: 37,
              b: 40,
              note: "An anniversary night with a Japanese singer in Harajuku, read forty in its second window.",
            },
            {
              id: "metallica",
              label: "Metallica collection",
              sub: "a band's name",
              a: 34,
              b: 33,
              tail: "−7",
              tailLow: true,
              note: "The crowd argued with it at minus seven in its first two windows, then read it at twenty-seven.",
            },
            {
              id: "nin",
              label: "Nine Inch Nails collection",
              sub: "a band's name",
              a: 40,
              b: 0,
              note: "The album boot, read once at zero.",
            },
            {
              id: "rick",
              label: "Rick Owens collection",
              sub: "a designer's name",
              a: 47,
              b: 0,
              note: "Your highest grade of the seven, read twice at zero.",
            },
          ],
        },
        {
          kind: "quadrant",
          insight:
            "Mexico City and São Paulo are hot and empty of you. Seoul and Tokyo are hot and already yours, so the next spend there is an upgrade, not a door.",
          title: "Where the scene is hot and you are absent",
          provenance: "projected",
          x: {
            label: "Scene heat",
            low: "quiet",
            high: "on fire",
            hint: "scene readiness from the map, the middle line at seventy",
          },
          y: {
            label: "Room for you",
            low: "your turf",
            high: "wide open",
            hint: "how few of your own and partner doors a city has, against your densest market",
          },
          quadrants: {
            tr: "Open door",
            tl: "Watch",
            br: "Defend",
            bl: "Home turf",
          },
          note: "Eight cities placed by how hot the scene runs and how much room you have left there. Dot size is the scene's size. The haloed dots are where the moves build. Modelled, not measured. Tap a dot for the read.",
          wLabel: "scene size",
          open: "mexico-city",
          points: [
            {
              id: "mexico-city",
              label: "Mexico City",
              short: "Beacon",
              color: "#4ADE80",
              x: 90,
              y: 79,
              w: 80,
              status: "recommended",
              note: "The hottest scene of the eight, and nothing of yours is open here yet. Your partner's Roma store is the first door, and the beacon builds on it.",
            },
            {
              id: "sao-paulo",
              label: "São Paulo",
              short: "Pop-up",
              color: "#4ADE80",
              x: 78,
              y: 83,
              w: 85,
              status: "recommended",
              note: "A shade cooler than Mexico City and the emptiest city for you, with no store, no partner and no play. A pop-up reads it first.",
            },
            {
              id: "bangkok",
              label: "Bangkok",
              color: "#94A3B8",
              x: 68,
              y: 74,
              w: 70,
              status: "current",
              note: "A hot city where you sell only through partners. The one to watch after Roma and São Paulo.",
            },
            {
              id: "seoul",
              label: "Seoul",
              color: "#94A3B8",
              x: 85,
              y: 35,
              w: 75,
              status: "current",
              note: "Hot and already yours, with eighteen stores in Korea and your newest brand centre in Seoul.",
            },
            {
              id: "tokyo",
              label: "Tokyo",
              color: "#94A3B8",
              x: 55,
              y: 9,
              w: 85,
              status: "current",
              note: "Your densest market in Asia, in a scene still warm. Defend it with the doors you have.",
            },
            {
              id: "london",
              label: "London",
              color: "#94A3B8",
              x: 45,
              y: 13,
              w: 80,
              status: "current",
              note: "Your home and your first beacon. The scene runs cooler than in the cities above it, and your European stores are selling less.",
            },
            {
              id: "new-york",
              label: "New York",
              color: "#94A3B8",
              x: 40,
              y: 41,
              w: 90,
              status: "current",
              note: "A big scene with a closure beside every opening. Your brand centre upgrade covers it.",
            },
            {
              id: "lisbon",
              label: "Lisbon",
              color: "#94A3B8",
              x: 35,
              y: 82,
              w: 40,
              note: "Open room, but its own residents are cooling on the city. Watch it and hold the lease.",
            },
          ],
        },
        {
          kind: "cohorts",
          insight:
            "Roma's first buyer is the grown-up fan with money. Gen Z discovers you there, but this year it is cooling on the city.",
          title: "Who walks into Roma",
          provenance: "projected",
          note: "Three generations scored for how much of a Roma store's first years each could carry, from the public numbers above. Modelled, not measured. Tap a generation for the drivers.",
          open: "millennials",
          rows: [
            {
              id: "millennials",
              label: "Millennials",
              context: "twenty-five to thirty-four, the emo generation",
              score: 82,
              role: "First-year buyer",
              horizon: "long",
              drivers: [
                "Over half of emo streams in Mexico",
                "The boot they wanted at fifteen",
                "Festival weekends in the city",
              ],
            },
            {
              id: "genz",
              label: "Gen Z",
              context: "eighteen to twenty-four",
              score: 64,
              role: "Discovery",
              horizon: "short",
              drivers: [
                "A fifth of emo streams in Mexico",
                "Finds the boot through the scene, not the name",
                "Cooling on the city this year",
              ],
            },
            {
              id: "genx",
              label: "Gen X",
              context: "the rock en español core",
              score: 55,
              role: "Heritage anchor",
              horizon: "long",
              drivers: [
                "The festival headliners are their bands",
                "The Made in England boot they wore first",
              ],
            },
          ],
        },
        {
          kind: "plays",
          insight:
            "The three moves open a door, build a stage and run a test. The beacon makes Roma yours, the sessions make it the scene's, and the garage reads the next city before you pay for it.",
          title: "Three moves for Roma and the next city",
          provenance: "projected",
          plays: [
            {
              name: "Roma Beacon, your partner's Roma store opened as your first beacon outside London, with a café, a repair bar and a Made in England wall",
              itemType: "experience",
              window:
                "This winter, with the crowd's read at thirty and ninety days",
              strategies: [
                { code: "identity_signal", fit: 0.7 },
                { code: "aesthetic_innovation", fit: 0.5 },
              ],
              why: "Your partner has already announced the Roma store. Making it a beacon costs a fit-out, not a lease, and the café, the repair bar and the Made in England wall are the pieces that lifted your London price. Your name trails the scene in Mexico, so the store has to carry the whole brand.",
              effect: {
                label: "CIQ",
                delta: 1.0,
                series: [0, 0.3, 0.6, 0.8, 0.9, 1.0],
              },
              precedents: 3,
              reception:
                "your two Brewer Street plays read 40 and 47, the beacon formats read 80, the warmest read on your record, and every store opening on your record was read",
              similar: [
                {
                  brand: "hermes",
                  brandName: "Hermès",
                  title: "Maison Bond Street London flagship",
                  pts: 49.1,
                },
                {
                  brand: "dior",
                  brandName: "Dior",
                  title:
                    "Saint-Tropez boutique with the Monsieur Dior restaurant",
                  pts: 31.2,
                },
                {
                  brand: "saint-laurent",
                  brandName: "Saint Laurent",
                  title: "Saint Laurent Café, Avenue Montaigne",
                  pts: 26.4,
                },
              ],
            },
            {
              name: "Roma Sessions, monthly emo and rock nights in the store made with Mexican bands, bringing back the Dr. Martens Presents gig series",
              itemType: "event",
              window:
                "Monthly from the opening, the first headline night in festival week next March",
              strategies: [
                { code: "identity_signal", fit: 0.6 },
                { code: "fandom", fit: 0.4 },
              ],
              why: "The scene already gathers in the city. Nights made with local bands give people a reason to visit the store, not only to shop, and bring back the gig series your stores once toured. Fandom has never read warm for you, so this tests it on home ground.",
              effect: {
                label: "CIQ",
                delta: 0.8,
                series: [0, 0.2, 0.4, 0.6, 0.7, 0.8],
              },
              precedents: 2,
              reception:
                "your canal party read 53, your band collections read 0 to 33, and music plays on the rest of the board read 50 on average against your 29",
              similar: [
                {
                  brand: "zara",
                  brandName: "Zara",
                  title:
                    "Bad Bunny surprise appearance at Zara Plaza Las Américas",
                  pts: 27.1,
                },
                {
                  brand: "jacquemus",
                  brandName: "Jacquemus",
                  title: "Beach Club Takeover, Monte-Carlo",
                  pts: 46.7,
                },
                {
                  brand: "nike",
                  brandName: "Nike",
                  title: "NIGO, From Japan with Love exhibition and pop-up",
                  pts: 37.0,
                },
              ],
            },
            {
              name: "Barra Funda Garage, a ninety-day repair and gig pop-up in São Paulo before any lease",
              itemType: "experience",
              window:
                "Ninety days from the city's big festival week next March",
              strategies: [
                { code: "aesthetic_innovation", fit: 0.6 },
                { code: "scarcity", fit: 0.4 },
              ],
              why: "Brazil has no store and no partner of yours. A pop-up lets the crowd read the city before anyone signs a lease, and the repair bar is the easiest piece of the beacon to move. No fashion brand on the board has played São Paulo, so the first one sets the bar.",
              effect: {
                label: "CIQ",
                delta: 0.5,
                series: [0, 0.2, 0.4, 0.5, 0.5, 0.5],
              },
              precedents: 3,
              reception:
                "no brand on the fashion board has a play in São Paulo, and the crowd read the board's pop-ups up to 80",
              similar: [
                {
                  brand: "louis-vuitton",
                  brandName: "Louis Vuitton",
                  title: "Louis Vuitton Hotel London",
                  pts: 49.2,
                },
                {
                  brand: "valentino",
                  brandName: "Valentino",
                  title: "Valentino Beauty House Party Pop-Up",
                  pts: 35.8,
                },
              ],
            },
          ],
          footnote:
            "Projected effects are priced on your measured record and the public facts in the file header, and compound with your current course.",
        },
        {
          kind: "impact",
          title: "What the three moves carry",
          provenance: "projected",
          delta: 2.3,
          body: "Just over two points on your published score, from 65.39 to roughly 67.7, past Saint Laurent and a fifth of a point short of Hermès. Most of it comes from the shelf you score lowest on, where every door you have opened was read. The qualifier is your name. In Mexico it trails the scene, so the beacon has to earn searches before it earns sales.",
        },
        {
          kind: "modelView",
          body: "The scene is real and it is not waiting for you. Mexico City listens to the music your boot grew up with more every year, and the brands that sell to scenes have already picked Roma. The tell is that your own partner chose the same neighbourhood before this answer did.\n\nWhat cannot be read yet is the brand itself. Searches for your name in Mexico are small and flat, and nothing you have made there has been measured. The store is the first thing the record will see, so open the version that carries the whole brand, not the one that only sells boots.\n\nOpen Roma as a beacon, fill it with the scene's own bands, and test São Paulo with a pop-up before a lease. Do not call it expansion. Your estate stays flat, and this is where the doors you already have earn their keep.",
        },
      ],
    },
  ],
};
